// ─────────────────────────────────────────────────────────────────────────────
// navigation.js  —  Celebrity Smile Studio, Flourtown PA
//
// Content sourced and adapted from flourtowndentist.com (Celebrity Smile Studio),
// the same dental group, re-localized for the Flourtown office.
//
// HOW TO EDIT INNER PAGE CONTENT
// ──────────────────────────────
// Every page has a `content` field that accepts raw HTML.
// Supported tags: <h2> <h3> <h4> <p> <ul> <ol> <li> <strong> <em>
//                 <a> <img> <blockquote> <table> <hr>
//                 <div class="info-box|warning-box|success-box">
// ─────────────────────────────────────────────────────────────────────────────

// ─── NAV STRUCTURE ───────────────────────────────────────────────────────────
export const NAV_ITEMS = [
  {
    label: 'Services',
    path: '/services',
    children: [
      {
      },
      {
        label: 'Cosmetic Dentistry | Enhance Your Smile',
        path: '/services/cosmetic-dentistry',
        icon: '✨',
        hasSubmenu: true,
        submenu: [
          { label: 'Dental Implants | Restore Your Smile',  path: '/services/cosmetic-dentistry/dental-implants' },
          { label: 'Full Arch Restoration',                  path: '/services/cosmetic-dentistry/full-arch-restoration' },
          { label: 'All-on-4® Dental Implants',             path: '/services/cosmetic-dentistry/all-on-4-dental-implants' },
          { label: 'Teeth-In-A-Day',                        path: '/services/cosmetic-dentistry/teeth-in-a-day' }, 
          { label: 'Orthodontics | Straighten Your Smile',  path: '/services/cosmetic-dentistry/orthodontics' },
          { label: 'Botox',  path: '/services/cosmetic-dentistry/botox' }, 
          { label: 'TMJ',  path: '/services/cosmetic-dentistry/tmj' }, 
        ],
      },
      {
        label: 'Expert Oral Surgery',
        path: '/services/oral-surgery',
        icon: '🔬',
        hasSubmenu: true,
        submenu: [
          { label: 'Tooth Extraction', path: '/services/oral-surgery/tooth-extraction' },
        ],
      },
      {
        label: 'Endodontics | Save Your Tooth',
        path: '/services/endodontics',
        icon: '🌊',
        hasSubmenu: true,
        submenu: [
          { label: 'Root Canal Treatment', path: '/services/endodontics/root-canal-treatment' },
        ],
      },
      {
        label: 'Periodontist | Gum Health Experts',
        path: '/services/periodontist',
        icon: '🦷',
        hasSubmenu: true,
        submenu: [
          { label: 'LANAP Procedure', path: '/services/periodontist/lanap-procedure' },
        ],
      },
      {
        label: 'Preventative Dental Care',
        path: '/services/preventative-dental-care',
        icon: '🛡️',
        hasSubmenu: true,
        submenu: [
          { label: 'Comprehensive Dental Examinations', path: '/services/preventative-dental-care/dental-examinations' },
          { label: 'Dental X-Rays',                     path: '/services/preventative-dental-care/dental-x-rays' },
          { label: 'Professional Dental Cleaning',      path: '/services/preventative-dental-care/dental-cleaning' },
        ],
      },
      { label: 'Family Dentist', path: '/services/family-dentist', icon: '🏥' },
    ],
  },
  {
    label: 'Doctors',
    path: '/doctors',
    children: [
      { label: 'Dr. Taral T. Mehta',  path: '/doctors/dr-mehta',  icon: '👨‍⚕️' },
      { label: 'Dr. Randy Nolf',   path: '/doctors/dr-randy-nolf',   icon: '👨‍⚕️' },
      { label: 'Dr. Nishit Sachde',  path: '/doctors/dr-nishit-sachde',  icon: '👨‍⚕️' },
      { label: 'Dr. David Sopinsky',  path: '/doctors/dr-sopinsky',  icon: '👨‍⚕️' },
      { label: 'Dr. Kaushal Shah',  path: '/doctors/dr-kaushal-shah',  icon: '👩‍⚕️' },
    ],
  },
  {
    label: 'Patient Center',
    path: '/patient-center',
    children: [
     // { label: 'Patient Portal',       path: 'https://app.modento.io/celebrity-smiles-llc',  icon: '🔐', external: true },
      { label: 'Patient Financing',    path: '/patient-center/financing',         icon: '💳' },
      { label: 'Patient Testimonials', path: '/patient-center/testimonials',      icon: '⭐' },
      //{ label: 'Office Tour',          path: '/patient-center/office-tour',       icon: '🏢' },
      // { label: 'Common Questions',     path: '/patient-center/common-questions',  icon: '❓' },
      { label: 'Smile Gallery',        path: '/patient-center/smile-gallery',     icon: '😁' },
      //{ label: 'New Patient Forms',    path: '/patient-center/new-patient-forms',  icon: '📋' },
      //{ label: 'Patient Survey',       path: '/patient-center/patient-survey',    icon: '📋' },
      //{ label: 'Office Policies',      path: '/patient-center/office-policies',   icon: '📄' }, 
      //{ label: 'Dental Links',         path: '/patient-center/dental-links',      icon: '🔗' },
      //{ label: 'Emergency Care',       path: '/patient-center/emergency-care',    icon: '🚨' },  
      //{ label: 'Video',                path: '/patient-center/video',             icon: '🎥' },
    ],
  },
 // { label: 'Blog', path: '/blog' },
  {
    label: 'Contact',
    path: '/contact',
    children: [
      { label: 'Book Online',      path: '/book-appointment',           icon: '📅' },
      { label: 'Location',         path: '/contact/location',           icon: '📍' },
      //{ label: 'Your First Visit', path: '/contact/your-first-visit',   icon: '🦷' },
    ],
  },
];

// ─── SERVICES DATA ────────────────────────────────────────────────────────────
export const SERVICES_DATA = [
  {
    num: '01', icon: '✨',
    title: 'Cosmetic Dentistry',
    slug: 'cosmetic-dentistry',
    featured: true,
    excerpt: 'Expert cosmetic care to enhance your smile — implants, orthodontics, full arch restoration and more.',
    description: 'Your smile is your signature. At Celebrity Smile Studio in Flourtown, we believe everyone deserves a smile they truly love.',
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=800&q=80',
    content: `
<h1>Cosmetic Dentistry | Enhance Your Smile</h1>
<h3>Transform Your Smile with Expert Cosmetic Dentistry in Flourtown</h3>
<p>Your smile is often the first thing people notice—it reflects your confidence, personality, and overall well-being. At Celebrity Smile Studio in Flourtown, we are dedicated to helping you achieve a beautiful, natural-looking smile you’ll feel proud to share.</p>
<p>Our comprehensive cosmetic dentistry services are designed to enhance the appearance of your teeth while improving your confidence and quality of life. Whether you’re concerned about stained teeth, chips, gaps, minor misalignment, or uneven spacing, our experienced team provides customized solutions tailored to your goals.</p>
<h3>Comprehensive Cosmetic Dentistry Services</h3>
<p>We offer a full range of advanced cosmetic dental treatments in Flourtown, including:</p>
<ul>
  <li><strong>Professional Teeth Whitening</strong> — Safely brighten your smile with our in-office whitening treatments or convenient take-home whitening kits designed for noticeable, long-lasting results.</li>

<li><strong>Porcelain Veneers</strong> —
Transform your smile with custom-crafted porcelain veneers that conceal discoloration, chips, gaps, and minor alignment issues—delivering a flawless yet natural appearance.</li>

<li><strong>Dental Bonding</strong> —
Repair small imperfections such as cracks, chips, and spaces with a quick, affordable, and minimally invasive cosmetic solution.</li>

<li><strong>Invisalign™ Clear Aligners</strong> —
Straighten your teeth discreetly and comfortably with nearly invisible aligners—without the need for traditional metal braces.</li>

<li><strong>Custom Smile Makeovers</strong> —
Combine multiple cosmetic treatments into a personalized smile transformation plan designed around your ideal results.</li>

<h3>Why Choose Celebrity Smile Studio for Cosmetic Dentistry in Flourtown?</h3>

<li><strong>An Artistic, Detail-Oriented Approach</strong> —
Cosmetic dentistry is both science and art. We focus on creating balanced, harmonious smiles that enhance your natural features.</li>

<li><strong>Personalized Treatment Plans</strong> —
We take the time to understand your goals, concerns, and expectations, developing a customized plan that fits your lifestyle and budget.</li>

<li><strong>Advanced Dental Technology</strong> —
Our modern techniques and technology ensure precise, efficient, and comfortable treatment experiences.</li>

<li><strong>Experienced & Compassionate Team</strong> —
Our skilled dental professionals are passionate about delivering exceptional results and making every patient feel at ease.</li>

<li><strong>Community-Focused Care</strong> —
As proud members of the Flourtown community, we are committed to providing trusted, high-quality cosmetic dental care to our neighbors.</li>

<li><strong>Natural-Looking Results</strong> —
Our priority is enhancing your smile—not changing who you are. We aim for results that look beautifully natural and authentically you.</li>

<p>A confident smile can positively impact every area of your life—from personal relationships to professional opportunities. Let us help you achieve the radiant, confident smile you’ve always envisioned.<p>

<p><strong>Schedule your cosmetic dentistry consultation at Celebrity Smile Studio in Flourtown today and take the first step toward your dream smile.</strong></p>

    `,
    seo: {
      title: 'Cosmetic Dentistry Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Transform your smile with cosmetic dentistry at Celebrity Smile Studio in Flourtown. From whitening to veneers, we offer expert treatments for a radiant smile.',
      keywords: 'cosmetic dentistry Flourtown, dental implants Flourtown, smile makeover, veneers Flourtown, teeth whitening Flourtown',
    },
  },
  {
    num: '02', icon: '🔬',
    title: 'Expert Oral Surgery',
    slug: 'oral-surgery',
    excerpt: 'Expert oral surgery services — precise, comfortable, and performed in a modern Flourtown office.',
    description: 'Sometimes achieving optimal oral health requires specialized surgical procedures. Our skilled oral surgery team is dedicated to providing expert care with a focus on patient comfort.',
    image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=800&q=80',
    content: `
<h1>Expert Oral Surgery</h1>
<h3>Advanced Oral Surgery Services for a Healthier Smile at Celebrity Smile Studio</h3>

<p>At <strong>Celebrity Smile Studio in Flourtown</strong>, we understand that achieving optimal oral health sometimes requires specialized surgical care.</p>

<p>Our experienced oral surgery team is committed to delivering safe, precise, and comfortable treatment tailored to your unique needs.</p>

<p>From your first consultation to your final follow-up visit, we prioritize your comfort, safety, and long-term results.</p>

<p>We know that the idea of oral surgery can feel overwhelming.</p>

<p>That’s why we focus on clear communication, compassionate care, and advanced techniques to ensure a smooth and stress-free experience.</p>

<p>Our goal is not just to perform procedures—but to restore your oral health, function, and confidence.</p>


<h3>Comprehensive Oral Surgery Procedures We Offer</h3>

<ul>
<li><strong>Dental Implant Placement</strong> — Surgically placing biocompatible titanium posts into the jawbone to create a strong, stable foundation for natural-looking replacement teeth.</li>

<li><strong>Wisdom Teeth Removal</strong> — Safe and efficient extraction of impacted, infected, or painful third molars to prevent future complications.</li>

<li><strong>Tooth Extractions</strong> — Simple and complex tooth removals due to severe decay, infection, trauma, or orthodontic needs.</li>

<li><strong>Bone Grafting</strong> — Strengthening and rebuilding the jawbone to support dental implants and restorative treatments.</li>

<li><strong>Sinus Lift Procedure</strong> — Increasing bone height in the upper jaw to ensure successful dental implant placement.</li>

<li><strong>Frenectomy</strong> — Gently releasing restrictive lip or tongue tissue to improve speech, comfort, and oral function.</li>

<li><strong>Oral Pathology &amp; Biopsies</strong> — Diagnosing and treating oral diseases, including performing biopsies for suspicious lesions.</li>

<li><strong>Corrective Jaw Surgery (Orthognathic Surgery)</strong> — Correcting skeletal and bite irregularities to enhance chewing function, facial balance, and overall oral health.</li>

<li><strong>TMJ Disorder Treatment</strong> — Surgical solutions for severe temporomandibular joint pain and jaw dysfunction when conservative therapies are not effective.</li>

<li><strong>Dental Trauma Management</strong> — Surgical repair of injuries affecting teeth, gums, and jaw structures.</li>
</ul>


<h3>What to Expect During Your Oral Surgery Experience</h3>

<p>We follow a structured, patient-centered approach to ensure safe and successful outcomes.</p>

<ul>
<li><strong>Comprehensive Consultation &amp; Evaluation</strong> — Detailed examination and advanced imaging to assess your condition and discuss treatment options.</li>

<li><strong>Personalized Treatment Planning</strong> — A customized surgical plan designed around your oral health goals and medical history.</li>

<li><strong>Comfort-Focused Anesthesia Options</strong> — Local anesthesia, sedation dentistry, and general anesthesia options to ensure a relaxed experience.</li>

<li><strong>Advanced Surgical Techniques</strong> — Minimally invasive methods to reduce discomfort and promote faster healing.</li>

<li><strong>Strict Sterilization Protocols</strong> — A clean, modern surgical environment that meets the highest safety standards.</li>

<li><strong>Detailed Post-Operative Instructions</strong> — Clear recovery guidelines to help you heal comfortably at home.</li>

<li><strong>Ongoing Follow-Up Care</strong> — Scheduled visits to monitor healing and ensure optimal results.</li>
</ul>


<h3>Why Choose Celebrity Smile Studio for Oral Surgery in Flourtown?</h3>

<ul>
<li><strong>Experienced Oral Surgeons</strong> — Highly trained professionals with expertise in a full range of oral surgical procedures.</li>

<li><strong>State-of-the-Art Technology</strong> — Advanced equipment and modern surgical suites for precise, predictable outcomes.</li>

<li><strong>Patient Comfort &amp; Safety First</strong> — Every procedure is performed with your well-being as our top priority.</li>

<li><strong>Comprehensive Care Under One Roof</strong> — Seamless coordination from consultation to recovery within our practice.</li>

<li><strong>Clear &amp; Honest Communication</strong> — We thoroughly explain your procedure, answer your questions, and ensure you feel confident about your treatment plan.</li>

<li><strong>Collaborative Dental Care</strong> — We work closely with your general dentist and specialists to provide coordinated care.</li>

<li><strong>Focus on Long-Term Results</strong> — Our treatments are designed to improve oral health, restore function, and enhance your quality of life.</li>

<li><strong>Compassionate, Supportive Team</strong> — Dedicated to making your experience positive, comfortable, and stress-free.</li>
</ul>

<p>If you’re in need of expert oral surgery in Flourtown, trust the skilled team at <strong>Celebrity Smile Studio</strong> to provide exceptional care in a comfortable setting.</p>

<p>Contact us today to schedule your consultation and take the first step toward improved oral health and a confident smile.</p>
    `,
    seo: {
      title: 'Expert Oral Surgery | Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Discover expert oral surgery in Flourtown at Celebrity Smile Studio. From wisdom teeth to implants, our skilled team delivers advanced surgical care with comfort, compassion, and precision.',
      keywords: 'oral surgery flourtown, tooth extraction flourtown, wisdom teeth removal, dental implant surgery flourtown',
    },
  },
  {
    num: '03', icon: '🌊',
    title: 'Endodontics | Save Your Tooth',
    slug: 'endodontics',
    excerpt: 'Advanced endodontic care to save your natural tooth — comfortable, precise, and effective.',
    description: 'When the inner pulp of a tooth becomes infected or damaged, you need specialized care to save it. Our expert endodontics services are designed to relieve pain and preserve your natural teeth.',
    image: 'https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?w=800&q=80',
    content: `
<h1>Endodontics | Save Your Tooth</h1>
<h3>Expert Endodontic Care to Relieve Pain &amp; Preserve Your Smile</h3>

<p>When the inner pulp of a tooth becomes infected or inflamed, prompt treatment is essential to prevent further damage and relieve discomfort.</p>

<p>At <strong>Celebrity Smile Studio in Flourtown</strong>, our advanced endodontic treatments — including root canal therapy — are designed to eliminate infection, relieve pain, and save your natural tooth whenever possible.</p>

<p>We understand that many patients feel anxious about root canal treatment. Our experienced dental team focuses on gentle techniques, modern technology, and compassionate care to ensure a comfortable and stress-free experience.</p>

<p>Preserving your natural teeth is always our priority, and we are committed to delivering precise, effective endodontic care that restores both function and confidence in your smile.</p>


<h3>Signs You May Need Endodontic (Root Canal) Treatment</h3>

<ul>
<li><strong>Severe or Persistent Tooth Pain</strong> — Often a sign of infection or inflammation inside the tooth pulp.</li>

<li><strong>Lingering Sensitivity to Hot or Cold</strong> — Pain that continues even after the source of temperature is removed.</li>

<li><strong>Swollen or Tender Gums</strong> — Inflammation around a specific tooth.</li>

<li><strong>Tooth Discoloration</strong> — Darkening of the tooth due to internal damage.</li>

<li><strong>Dental Abscess</strong> — A small pimple-like bump on the gums indicating infection.</li>
</ul>


<h3>What to Expect During Your Endodontic Treatment at Celebrity Smile Studio</h3>

<ul>
<li><strong>Comprehensive Examination &amp; Diagnosis</strong> — Detailed evaluation and digital imaging to determine the extent of infection.</li>

<li><strong>Comfortable Local Anesthesia</strong> — Ensuring the procedure is completely pain-free.</li>

<li><strong>Removal of Infected Pulp</strong> — Carefully cleaning and shaping the root canal to eliminate bacteria.</li>

<li><strong>Filling &amp; Sealing the Canal</strong> — Protecting the tooth from future infection.</li>

<li><strong>Final Restoration</strong> — Placement of a dental crown or filling to strengthen and restore full function.</li>
</ul>


<h3>Why Choose Celebrity Smile Studio for Endodontics in Flourtown?</h3>

<ul>
<li><strong>Experienced Endodontic Team</strong> — Skilled in providing gentle and precise root canal therapy.</li>

<li><strong>Advanced Dental Technology</strong> — Modern equipment for accurate diagnosis and efficient treatment.</li>

<li><strong>Comfort-Focused Care</strong> — A relaxing environment designed to reduce dental anxiety.</li>

<li><strong>Commitment to Saving Natural Teeth</strong> — We prioritize preserving your original tooth whenever possible.</li>

<li><strong>Personalized Treatment Plans</strong> — Customized care based on your unique dental needs.</li>

<li><strong>Trusted Flourtown Dental Practice</strong> — Proudly serving our local community with high-quality dental care.</li>

<li><strong>Clear &amp; Honest Communication</strong> — We explain every step of your treatment so you feel confident and informed.</li>
</ul>

<p>Saving your natural teeth is essential for maintaining long-term oral health and proper bite function.</p>

<p>If you are experiencing tooth pain or believe you may need root canal treatment in Flourtown, contact <strong>Celebrity Smile Studio</strong> today to schedule a consultation and restore your smile comfortably and effectively.</p>
    `,
    seo: {
      title: 'Expert Endodontics Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Save your natural tooth with expert endodontics. Celebrity Smile Studio provides gentle root canal treatments to relieve pain and restore your smile.',
      keywords: 'root canal flourtown, endodontics flourtown, root canal treatment, save tooth flourtown',
    },
  },
  {
    num: '04', icon: '🦷',
    title: 'Periodontist | Gum Health Experts',
    slug: 'periodontist',
    excerpt: 'Expert periodontal care to protect your gums and the foundation of your smile.',
    description: 'Healthy gums are the foundation of a healthy smile. Our periodontal services address gum disease at every stage using the most advanced treatments available.',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&q=80',
    content: `
<h1>Periodontist | Gum Health Experts</h1>
<h3>Protect Your Gums, Protect Your Health at Celebrity Smile Studio</h3>

<p>Healthy gums are the foundation of a strong, beautiful smile and overall wellness.</p>

<p>At <strong>Celebrity Smile Studio in Flourtown</strong>, our experienced periodontist provides specialized care to diagnose, treat, and prevent gum disease (periodontal disease) with precision and compassion.</p>

<p>Gum disease is more than a dental concern — it has been linked to serious systemic health conditions, making early diagnosis and treatment essential for protecting both your oral and overall health.</p>

<p>Whether you need preventive therapy or advanced periodontal treatment, our team is committed to restoring your gum health in a comfortable and supportive environment.</p>


<h3>Why See a Periodontist?</h3>

<ul>
<li><strong>Advanced Specialized Training</strong> — A periodontist has extensive education in diagnosing and treating gum disease and complex periodontal conditions.</li>

<li><strong>Comprehensive Periodontal Treatments</strong> — Services include scaling and root planing (deep cleaning), gum grafting, periodontal therapy, and dental implant placement.</li>

<li><strong>Preventive Gum Care</strong> — Early intervention and maintenance programs to protect against future gum disease progression.</li>

<li><strong>Personalized Treatment Plans</strong> — Customized care tailored to your oral health condition and long-term goals.</li>

<li><strong>Comfort-Focused Approach</strong> — Gentle techniques and patient-centered care to minimize discomfort.</li>

<li><strong>Trusted Flourtown Dental Practice</strong> — Proudly serving the local community with advanced periodontal expertise.</li>
</ul>


<h3>Signs You May Need Periodontal Treatment</h3>

<ul>
<li><strong>Bleeding Gums</strong> — Especially while brushing or flossing.</li>

<li><strong>Red, Swollen, or Tender Gums</strong> — Indicators of inflammation or infection.</li>

<li><strong>Persistent Bad Breath</strong> — Often caused by bacteria beneath the gumline.</li>

<li><strong>Receding Gums</strong> — Teeth appearing longer due to gum tissue loss.</li>

<li><strong>Loose or Shifting Teeth</strong> — A possible sign of advanced periodontal disease.</li>

<li><strong>Changes in Bite Alignment</strong> — Noticeable differences in how teeth fit together.</li>
</ul>


<h3>Comprehensive Periodontal Care for Long-Term Health</h3>

<p>Our periodontist is dedicated to helping you achieve and maintain healthy gums for life through advanced diagnostics, modern treatment techniques, and ongoing maintenance care.</p>

<p>We believe in early intervention, clear communication, and compassionate service to ensure you feel informed and confident about your treatment options.</p>

<p>Don’t let gum disease compromise your smile or overall health.</p>

<p>Schedule your consultation with the expert periodontist at <strong>Celebrity Smile Studio in Flourtown</strong> today and take the first step toward healthier gums and a stronger smile.</p>
    `,
    seo: {
      title: 'Periodontics Flourtown | Periodontal Therapy - Celebrity Smile Studio',
      description: 'Expert periodontist in Flourtown. Celebrity Smile Studio provides specialized gum care, protecting your smile &amp; overall health. Address gum disease concerns today!',
      keywords: 'periodontist flourtown, gum disease treatment flourtown, LANAP flourtown, periodontal therapy',
    },
  },
  {
    num: '05', icon: '🛡️',
    title: 'Preventative Dental Care',
    slug: 'preventative-dental-care',
    excerpt: 'Comprehensive preventative care — the foundation of a healthy smile for life.',
    description: 'Preventative dentistry is the cornerstone of long-term oral health. Through regular exams, cleanings, and patient education, we help you avoid costly problems before they start.',
    image: 'https://images.unsplash.com/photo-1588776814546-1ffbb93a5289?w=800&q=80',
    content: `
<h1>Preventative Dental Care in Flourtown</h1>

<h3>The Foundation of Lifelong Oral Health at Celebrity Smile Studio</h3>

<p>Imagine enjoying a bright, healthy smile for years to come — free from unexpected dental problems.</p>

<p>At <strong>Celebrity Smile Studio in Flourtown</strong>, we believe preventative dental care is the key to long-term oral health and overall wellness.</p>

<p>Rather than simply treating dental issues as they arise, our proactive approach focuses on preventing cavities, gum disease, and other concerns before they become costly or uncomfortable.</p>

<p>Preventative dentistry acts as your smile’s first line of defense, combining routine check-ups, professional cleanings, advanced diagnostics, and personalized education to keep your teeth and gums in optimal condition.</p>

<p>We empower you to take an active role in your oral health through guidance, early detection, and customized care plans designed specifically for you.</p>


<h3>Key Components of Preventative Dental Care at Celebrity Smile Studio</h3>

<ul>
<li><strong>Comprehensive Dental Examinations</strong> — Thorough evaluations to detect early signs of cavities, gum disease, oral cancer, and other concerns.</li>

<li><strong>Professional Dental Cleanings</strong> — Removal of plaque and tartar buildup to protect teeth and maintain healthy gums.</li>

<li><strong>Digital Dental X-Rays</strong> — Advanced imaging technology to identify hidden issues with precision and minimal radiation exposure.</li>

<li><strong>Personalized Oral Hygiene Education</strong> — Tailored brushing, flossing, and at-home care recommendations.</li>

<li><strong>Fluoride Treatments &amp; Dental Sealants</strong> — Preventative solutions to strengthen enamel and reduce cavity risk.</li>

<li><strong>Gum Disease Prevention &amp; Monitoring</strong> — Early intervention to protect against periodontal disease.</li>

<li><strong>Nutritional &amp; Lifestyle Guidance</strong> — Education on how diet and daily habits impact your oral health.</li>
</ul>


<h3>Why Choose Celebrity Smile Studio for Preventative Dentistry in Flourtown?</h3>

<ul>
<li><strong>Proactive, Prevention-Focused Care</strong> — Helping you avoid complex dental treatments whenever possible.</li>

<li><strong>Personalized Preventative Plans</strong> — Customized strategies based on your individual risk factors and dental history.</li>

<li><strong>Experienced &amp; Compassionate Team</strong> — Dedicated to gentle, thorough, and patient-centered care.</li>

<li><strong>Modern Dental Technology</strong> — State-of-the-art tools for accurate diagnosis and comfortable treatment.</li>

<li><strong>Patient Education &amp; Empowerment</strong> — Providing the knowledge you need to maintain a healthy smile at home.</li>

<li><strong>Commitment to the Flourtown Community</strong> — Proudly serving local families with trusted preventative dental care.</li>

<li><strong>Focus on Long-Term Health</strong> — Prioritizing sustainable oral wellness over temporary fixes.</li>
</ul>

<p>Preventative dental care is an investment in your smile, your confidence, and your overall health.</p>

<p>By taking proactive steps today, you can enjoy a strong, healthy smile for years to come.</p>

<p>Schedule your preventative dental care appointment at <strong>Celebrity Smile Studio in Flourtown</strong> and take control of your oral health today.</p>
    `,
    seo: {
      title: 'Preventative Dental Care Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Prevent problems before they begin with personalized preventative dental care at Celebrity Smile Studio. Your smile’s first line of defense starts here.',
      keywords: 'preventative dental care flourtown, dental cleaning flourtown, dental exam flourtown, oral cancer screening',
    },
  },
  {
    num: '06', icon: '🏥',
    title: 'Family Dentist',
    slug: 'family-dentist',
    excerpt: 'Comprehensive dental care for every member of your family — from toddlers to seniors.',
    description: 'Finding the right dental care for your entire family can feel like a big decision. At Celebrity Smile Studio, we are your families dental home — where everyone feels comfortable and receives exceptional care.',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    content: `
<h1>Family Dentist in Flourtown</h1>
<h3>Your trusted family dentist in Flourtown — caring for smiles of all ages at Celebrity Smile Studio.</h3> 
<p>Choosing the right dental home for your family is an important decision. At Celebrity Smile Studio, we provide comprehensive, compassionate dental care designed to meet the needs of children, teens, adults, and seniors — all under one roof.</p>
<p>We are more than just a dental office. We are your long-term partner in maintaining healthy, confident smiles for every stage of life. From your child’s first dental visit to ongoing care for adults and seniors, our team is committed to delivering exceptional family dentistry in a warm, welcoming environment.</p>

<h3>Comprehensive Family Dental Care for Every Generation</h3>
<ul>
  <li><strong>Children’s Dentistry</strong> — Gentle, positive dental experiences focused on prevention, education, and building lifelong healthy habits.</li>
  <li><strong>Routine Exams & Professional Cleanings</strong> — Regular checkups help prevent cavities, gum disease, and other oral health concerns for patients of all ages.</li>
  <li><strong>Preventive Treatments</strong> — Fluoride treatments and dental sealants protect both young and adult teeth from decay.</li>
  <li><strong>Restorative Dentistry</strong> — Tooth-colored fillings, crowns, and bridges restore strength, function, and appearance to damaged teeth.</li>
  <li><strong>Orthodontic Evaluations</strong> — Early assessments and guidance for braces or alignment treatments for children, teens, and adults.</li>
  <li><strong>Gum Disease Treatment</strong> — Comprehensive periodontal care to protect your gums and overall oral health.</li>
  <li><strong>Cosmetic Dentistry</strong> — Professional teeth whitening and veneers to enhance your smile with confidence.</li>
  <li><strong>Emergency Dental Care</strong> — Prompt attention when unexpected dental problems arise.</li>
  <li><strong>Patient Education</strong> — Personalized guidance to help your family maintain excellent oral hygiene at home.</li>
</ul>

<h3>Why Families in Flourtown Choose Celebrity Smile Studio</h3>
<ul>
  <li><strong>Comfortable & Family-Friendly Atmosphere</strong> — We create a relaxing, stress-free environment for patients of all ages.</li>
  <li><strong>Experienced & Compassionate Dental Team</strong> — Skilled professionals dedicated to treating every family member with patience and understanding.</li>
  <li><strong>Gentle, Patient-Centered Care</strong> — We prioritize comfort, especially for children and patients with dental anxiety.</li>
  <li><strong>Convenient Family Scheduling</strong> — Flexible appointments designed to fit busy family lifestyles.</li>
  <li><strong>Comprehensive Services in One Location</strong> — Simplified care with everything your family needs in one trusted dental office.</li>
  <li><strong>Prevention-Focused Approach</strong> — Proactive dental care to help avoid future complications and costly treatments.</li>
  <li><strong>Long-Term Relationships</strong> — We value the trust our patients place in us and strive to build lasting connections with every family we serve.</li>
  <li><strong>Clear Communication</strong> — We take time to explain treatment options and answer questions so you can make informed decisions.</li>
</ul>

<h3>Your Family’s Dental Home in Flourtown</h3>
<p>At Celebrity Smile Studio, we are committed to supporting your family’s oral health journey for years to come. Whether it’s your child’s first checkup, routine preventive care, or advanced dental treatment, our goal is to provide high-quality, personalized family dentistry in Flourtown.</p>
<p>Schedule your family’s appointments today and experience compassionate, comprehensive dental care designed to keep every smile healthy and bright.</p>
    `,
    seo: {
      title: 'Family Dentist Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Looking for a trusted family dentist in Flourtown? Celebrity Smile Studio offers gentle, comprehensive dental care for all ages. Making us your family’s go-to home for lifelong healthy smiles.',
      keywords: 'family dentist flourtown, kids dentist flourtown, pediatric dentist flourtown, family dental care',
    },
  },
];

// ─── SUB-PAGES DATA ───────────────────────────────────────────────────────────
export const SUB_PAGES_DATA = {
  'cosmetic-dentistry/dental-implants': {
    title: 'Dental Implants | Restore Your Smile',
    eyebrow: 'Cosmetic Dentistry',
    excerpt: 'Permanent, natural-looking tooth replacement that looks, feels, and functions like your real teeth.',
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=1600&q=80',
    seo: {
      title: 'Dental Implants Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Personalized dental implant solutions in Flourtown. Celebrity Smile Studio offers expert care from your local community dentist. Discover your options for a lasting smile!',
      keywords: 'dental implants flourtown, tooth replacement flourtown, implant dentist flourtown',
    },
    content: `
<h1>Dental Implants | Restore Your Smile</h1>
<h3>Restore Your Smile with Advanced Dental Implants in Flourtown</h3>
<p>Missing one or more teeth can impact more than just your appearance—it can affect your ability to chew comfortably, speak clearly, and feel confident in everyday interactions. At Celebrity Smile Studio in Flourtown, we offer advanced dental implant solutions designed to restore both the function and beauty of your smile.</p>
<p>Dental implants are widely regarded as the gold standard for tooth replacement. Unlike traditional dentures or bridges, implants are securely placed into the jawbone, creating a strong, stable foundation that looks, feels, and functions like natural teeth. With proper care, dental implants can provide a long-lasting solution that supports your overall oral health.</p>
<h3>Why Choose Dental Implants at Celebrity Smile Studio?</h3>
<ul>
  <li><strong>Experienced Implant Provider</strong> — Dr. Kaushal Shah and our skilled team have extensive experience in dental implant placement and restoration, ensuring precise and predictable results.</li>
  <li><strong>Personalized Treatment Plans</strong> — Every smile is unique. We carefully evaluate your oral health and design a customized implant treatment plan tailored to your goals and needs.</li>
  <li><strong>Advanced Technology & Imaging</strong> — We use modern diagnostic imaging and implant technology to ensure accurate placement, optimal healing, and long-term success.</li>
  <li><strong>Comfort-Focused Care</strong> — Your comfort is our priority. From your initial consultation through final restoration, we provide attentive, compassionate care every step of the way.</li>
  <li><strong>A Long-Term Tooth Replacement Solution</strong> — Dental implants are designed to integrate with your jawbone and can last for decades with proper oral hygiene and regular dental visits.</li>
  <li><strong>Community-Based Care in Flourtown</strong> — As proud members of the Flourtown community, we are committed to delivering high-quality, patient-centered dental care to our neighbors.</li>
  
  
<h3>The Dental Implant Process:</h3>
<p>Understanding what to expect can make your treatment journey smoother and more comfortable. Here’s a step-by-step overview:</p>
<ol>
  <li><strong>Comprehensive Consultation</strong> — We evaluate your oral health, review digital imaging, and discuss whether dental implants are right for you.</li>
  <li><strong>Implant Placement</strong> — A small titanium implant post is surgically placed into the jawbone, where it will serve as an artificial tooth root.</li>
  <li><strong>Healing & Osseointegration</strong> — Over the next few months, the implant naturally fuses with the jawbone, creating a strong and stable foundation. A temporary restoration may be provided during this period.</li>
  <li><strong>Abutment Placement</strong> — A small connector piece (abutment) is attached to the implant to support the final restoration.</li>
  <li><strong>Custom Restoration</strong> — A custom-designed crown, bridge, or implant-supported denture is securely placed, completing your fully restored smile.</li>
</ol>
<h3>Benefits of Dental Implants</h3>
<ul>
    <li>Restore natural chewing ability</li>
    <li>Improve speech clarity</li>
    <li>Prevent bone loss in the jaw</li>
    <li>Maintain facial structure</li>
    <li>Enhance confidence and overall quality of life</li>
</ul>
<p>Dental implants not only fill gaps—they help protect your long-term oral health and restore your confidence in daily life.</p>
<h3>Learn More About Dental Implants in Flourtown</h3>
<p>While this page provides a helpful overview, we understand you may want more detailed information about the procedure, recovery process, candidacy requirements, and long-term benefits. We invite you to explore our in-depth dental implant resource page to fully understand every aspect of treatment at Celebrity Smile Studio.</p>
<p><strong>Ready to take the next step? Schedule your dental implant consultation at Celebrity Smile Studio in Flourtown today and rediscover the confidence of a complete, healthy smile.</strong></p>
    `,
  },

  'cosmetic-dentistry/full-arch-restoration': {
    title: 'Full Arch Restoration',
    eyebrow: 'Cosmetic Dentistry',
    excerpt: 'Reclaim your complete smile — comprehensive full arch restoration for lasting confidence.',
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=1600&q=80',
    seo: {
      title: 'Full Arch Restoration Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Rediscover confidence with full arch restoration at Celebrity Smile Studio in Flourtown. From All-on-4® implants to hybrid solutions, we rebuild smiles with natural-looking, life-changing results.',
      keywords: 'full arch restoration flourtown, full mouth restoration, implant supported dentures flourtown',
    },
    content: `
<h1>Full Arch Restoration</h1>
<h3>Reclaim Your Smile with Full Arch Restoration in Flourtown</h3>
<p>Imagine the confidence of a complete, natural-looking smile. If you are missing most or all of your teeth in the upper or lower arch, full arch restoration at Celebrity Smile Studio in Flourtown can help you regain not only your smile, but also your comfort, function, and self-confidence.</p>
<p>Significant tooth loss can affect your ability to eat properly, speak clearly, and feel comfortable in social or professional settings. Our comprehensive full arch restoration solutions are designed to rebuild your smile from the foundation up—restoring strength, stability, and aesthetics for long-term success.</p>
<p>Full arch restoration is more than replacing teeth. It is a transformative treatment that restores your entire arch, improves oral health, and enhances overall quality of life.</p>
<h3>Our Full Arch Restoration Solutions</h3>
<p>At Celebrity Smile Studio, we offer advanced, customized options for full mouth and full arch tooth replacement, including:</p>
<ul>
  <li><strong>All-on-4® or All-on-X Implant Solutions</strong> — This innovative treatment uses strategically placed dental implants to support a full arch of custom-designed replacement teeth. Often requiring fewer implants than traditional methods, All-on-4® can provide a stable, efficient, and cost-effective full arch solution.</li>
  <li><strong>Implant-Supported Dentures</strong> — Unlike traditional removable dentures, implant-supported dentures are securely anchored to dental implants. This significantly improves stability, comfort, chewing ability, and confidence.</li>
  <li><strong>Hybrid Fixed Prostheses</strong> — These restorations combine the strength of dental implants with the natural aesthetics of a fixed bridge. Hybrid prostheses offer a durable, secure, and highly natural-looking full arch solution.</li>
  <li><strong>Multiple Individual Dental Implants</strong> — In certain cases, several strategically placed individual implants can support a full arch of crowns or a fixed bridge for optimal strength and long-term performance.</li>
 
</ul>
<h3>What to Expect During Your Full Arch Restoration Journey</h3>
<p>We guide you through every step with precision and compassionate care:</p>
<ul>
  <li><strong>Comprehensive Consultation and Evaluation</strong> — We begin with a detailed examination, advanced imaging, and a thorough discussion of your goals, health history, and treatment options.</li>
  <li><strong>Personalized Treatment Planning</strong> — Your full arch restoration plan is customized to your specific needs, anatomy, and desired outcomes.</li>
  <li><strong>Precise Implant Placement</strong> — Using advanced technology and modern surgical techniques, implants are placed accurately and comfortably for optimal integration and stability.</li>
  <li><strong>Custom Prosthesis Design</strong> — We collaborate with skilled dental technicians to craft a natural-looking, properly aligned, and comfortable full arch restoration.</li>
  <li><strong>Careful Fitting and Adjustments</strong> — We ensure your new smile feels comfortable, functions properly, and looks beautifully natural.</li>
  <li><strong>Ongoing Support and Maintenance</strong> — We provide detailed guidance and follow-up care to help protect your investment and ensure long-term success.</li>
</ul>
<h3>Why Choose Celebrity Smile Studio for Full Arch Restoration in Flourtown?</h3>
<ul>
  <li>Experienced Implant Specialists with advanced training in full arch procedures</li>
  <li>State-of-the-Art Technology for precise planning and predictable outcomes</li>
  <li>Compassionate, Patient-Centered Care throughout your entire journey</li>
  <li>Natural-Looking, Functional Results that restore full chewing and speaking ability</li>
  <li>Comprehensive Treatment Options tailored to your needs and budget </li>
  <li>Long-Term Durability & Stability designed for lasting performance</li>
  <li>Commitment to Improved Quality of Life through confident, complete smiles</li>
</ul>
<h3>Restore Your Confidence with a Complete Smile</h3>
<p>Full arch restoration can be life-changing—allowing you to eat comfortably, speak clearly, and smile without hesitation. If you are ready to rediscover the joy of a strong, confident smile, our team at Celebrity Smile Studio in Flourtown is here to help.</p>
<p><strong>Schedule your full arch restoration consultation today and take the first step toward reclaiming your smile.</strong></p>
    `,
  },

  'cosmetic-dentistry/all-on-4-dental-implants': {
    title: 'All-on-4® Dental Implants',
    eyebrow: 'Cosmetic Dentistry',
    excerpt: 'A full set of permanent teeth supported by just four strategically placed implants.',
    image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=1600&q=80',
    seo: {
      title: 'All-on-4® Dental Implants Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Restore your full smile in less time with All-on-4® Dental Implants at Celebrity Smile Studio in Flourtown. This advanced, minimally invasive implant solution offers stability, comfort, and a confident new beginning.',
      keywords: 'all on 4 dental implants flourtown, all on four implants, full arch implants flourtown',
    },
    content: `
<h1>All-on-4® Dental Implants</h1>
<h3>The Revolutionary All-on-4® Dental Implants in Flourtown</h3>
<h3>A Streamlined Path to a Complete, Confident Smile</h3>
<p>If you are missing most or all of your teeth in the upper or lower arch, the All-on-4® dental implant procedure at Celebrity Smile Studio in Flourtown offers an advanced, efficient, and life-changing solution. This innovative full arch restoration technique uses just four strategically placed dental implants to support a custom-designed, fixed set of replacement teeth—restoring strength, stability, and natural aesthetics.</p>
<p>All-on-4® is considered a breakthrough in modern restorative dentistry. By maximizing existing bone structure and minimizing the number of implants required, this technique often shortens treatment time and reduces the need for complex procedures such as bone grafting. The result is a faster, more comfortable journey to a complete and fully functional smile.</p>
<h3>Benefits of All-on-4® Dental Implants</h3>
<p>Choosing All-on-4® at Celebrity Smile Studio offers several important advantages:</p>
<ul>
  <li><strong>Fewer Implants, Full Arch Support</strong> — Four precisely angled implants are used to securely anchor a full arch of teeth, providing exceptional stability without the need for additional implant posts in most cases.</li>
  <li><strong>Reduced Treatment Time</strong> — Many patients qualify for same-day temporary teeth, meaning implants and a provisional prosthesis may be placed during a single visit.</li>
  <li><strong>Minimal or No Bone Grafting</strong> — The unique angulation of the back implants allows us to utilize available bone effectively, often eliminating the need for bone graft procedures.</li>
  <li><strong>Cost-Effective Full Arch Solution</strong> — Because fewer implants are required, All-on-4® can be more affordable than traditional full mouth implant reconstruction.</li>
  <li><strong>Superior Stability & Chewing Power</strong> — Unlike removable dentures, the fixed All-on-4® prosthesis does not slip or shift, allowing you to eat comfortably and confidently.</li>
  <li><strong>Natural Appearance & Comfort</strong> —Each prosthetic arch is custom-designed to look, feel, and function like natural teeth—restoring both appearance and self-esteem. </li>
</ul>
<h3>What to Expect During Your All-on-4® Treatment</h3>
<p>At Celebrity Smile Studio in Flourtown, we guide you through every phase with precision and compassionate care:</p>
<ol>
  <li><strong>Comprehensive Consultation & 3D Evaluation</strong> — We begin with a thorough exam and advanced digital imaging to determine if All-on-4® dental implants are the right option for you.</li>
  <li><strong>Customized Treatment Planning</strong> — Your treatment plan is tailored to your anatomy, oral health condition, and aesthetic goals.</li>
  <li><strong>Strategic Implant Placement</strong> — Four dental implants are precisely positioned in the jawbone for maximum support and long-term stability.</li>
  <li><strong>Immediate or Expedited Temporary Teeth</strong> — In many cases, a temporary set of fixed teeth is attached shortly after implant placement so you can leave with a functional smile.</li>
  <li><strong>Custom Final Prosthesis</strong> — After healing, a permanent, high-quality arch of teeth is fabricated to ensure optimal fit, strength, and natural beauty.</li>
  <li><strong>Final Placement & Adjustments</strong> — Your final restoration is securely attached and carefully adjusted for comfort, function, and aesthetics.</li>
  <li><strong>Ongoing Maintenance & Support</strong> — We provide detailed aftercare guidance and regular follow-ups to protect your investment and ensure lasting success.</li>
</ol>
<h3>Why Choose Celebrity Smile Studio for All-on-4® in Flourtown?</h3>
<ul>
  <li>Experienced Implant Specialists with advanced training in full arch implant techniques</li>
  <li>State-of-the-Art Imaging & Planning Technology for precise and predictable outcomes</li>
  <li>Efficient, Comfort-Focused Care designed to minimize downtime</li>
  <li>Comprehensive Full-Service Treatment from consultation to final restoration</li>
  <li>Long-Term Support & Maintenance Guidance</li>
  <li>Commitment to Patient Satisfaction & Life-Changing Results</li>
  
</ul>
<h3>Regain Your Complete Smile with All-on-4®</h3>
<p>The All-on-4® dental implant procedure offers a streamlined, stable, and highly effective solution for full arch tooth replacement. If you’re ready to restore your smile, improve your chewing ability, and regain your confidence, we’re here to help.</p>
<p><strong>Contact Celebrity Smile Studio in Flourtown today to schedule your All-on-4® consultation and discover if this innovative treatment is right for you.</strong></p>
    `,
  },

  'cosmetic-dentistry/teeth-in-a-day': {
    title: 'Teeth-In-A-Day',
    eyebrow: 'Cosmetic Dentistry',
    excerpt: 'Walk in with missing teeth — walk out the same day with a brand-new, fully functional smile.',
    image: 'https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?w=1600&q=80',
    seo: {
      title: 'Teeth-In-A-Day Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Achieve a full, functional smile in just one visit with Teeth-In-A-Day at Celebrity Smile Studio in Flourtown. Enjoy immediate results, expert care, and a life-changing transformation, fast.',
      keywords: 'teeth in a day flourtown, same day dental implants, immediate load implants flourtown',
    },
    content: `
<h1>Teeth-In-A-Day</h1>
<h3>Smile Transformation in a Single Visit: Teeth-In-A-Day in Flourtown</h3>
<p>Imagine arriving at our Flourtown office with missing or severely damaged teeth—and leaving the very same day with a complete, confident smile. At Celebrity Smile Studio, our advanced Teeth-In-A-Day procedure makes immediate smile restoration possible for qualified patients.</p>
<p>This innovative full arch dental implant solution streamlines the traditional multi-stage process, allowing you to receive dental implants and a fixed set of temporary teeth in just one appointment. The result? A faster, more convenient path to renewed confidence, function, and quality of life.</p>
<p>Teeth-In-A-Day isn’t just about speed—it’s about precision, planning, and delivering life-changing results with advanced technology and expert care.</p>
<h3>The Benefits of Teeth-In-A-Day</h3>
<ul>
  <li><strong>Immediate Smile Restoration</strong> — Walk out with a fully functional, natural-looking set of teeth on the same day as your implant surgery.</li>
  <li><strong>Shortened Treatment Timeline</strong> — Compared to traditional implant procedures that may take several months before teeth are placed, Teeth-In-A-Day significantly reduces the waiting period.</li>
  <li><strong>Minimal Disruption to Your Lifestyle</strong> — Return to your daily activities quickly with a stable, fixed smile—no extended time without teeth.</li>
  <li><strong>Strategic Implant Placement</strong> — Similar to All-on-4® concepts, strategically angled implants maximize support and efficiency, often using fewer implants.</li>
  <li><strong>Improved Comfort & Stability</strong> — Unlike removable dentures, your temporary prosthesis is securely attached, eliminating slipping or shifting.</li>
  <li><strong>Natural Appearance & Function</strong> — Eat, speak, and smile confidently from day one with teeth designed to look and feel natural.</li>
  <li><strong>Reduced Need for Bone Grafting</strong> — Advanced implant placement techniques often allow us to work with existing bone, minimizing additional procedures.</li>
</ul>
<h3>What to Expect During Your Teeth-In-A-Day Procedure</h3>
<p>At Celebrity Smile Studio in Flourtown, your journey is carefully planned and executed for optimal results:</p>
<ol>
  <li><strong>Comprehensive Consultation & 3D Imaging</strong> — We begin with a detailed examination and advanced digital scans to evaluate candidacy and plan treatment precisely.</li>
  <li><strong>Virtual Treatment Planning</strong> — Using specialized software, we map implant placement and design your new smile before surgery—ensuring accuracy and efficiency.</li>
  <li><strong>Precise Implant Placement</strong> — Our experienced implant team strategically places dental implants for maximum strength and stability.</li>
  <li><strong>Same-Day Temporary Teeth</strong> — A custom-designed temporary prosthesis is securely attached on the same day, allowing you to leave with a complete smile.</li>
  <li><strong>Healing & Integration Phase</strong> — Over the next few months, the implants fuse naturally with your jawbone (osseointegration), creating a solid foundation.</li>
  <li><strong>Final Custom Restoration</strong> — Once healing is complete, your permanent, custom-crafted full arch restoration is placed for optimal fit, strength, and aesthetics.</li>
  <li><strong>Ongoing Follow-Up Care</strong> — We provide detailed instructions and regular monitoring to protect your investment and ensure long-term success.</li>
</ol>
<h3>Why Choose Celebrity Smile Studio for Teeth-In-A-Day in Flourtown?</h3>
<ul>
  <li><strong>Experienced Implant Surgeons and Prosthodontists</strong> — Our collaborative team possesses the specialized skills and knowledge required for successful Teeth-In-A-Day procedures.</li>
  <li><strong>Cutting-Edge Technology and Techniques</strong> — We utilize the latest advancements in dental implantology to ensure precision and optimal outcomes.</li>
  <li><strong>Meticulous Planning and Execution</strong> — Our virtual planning and precise surgical techniques contribute to the efficiency and success of the procedure.</li>
  <li><strong>Focus on Patient Comfort and Satisfaction</strong> — We prioritize your comfort throughout the entire process and are dedicated to delivering a smile you’ll love.</li>
  <li><strong>Immediate and Dramatic Results</strong> — Experience the joy of a complete smile on the very day of your procedure.</li>
  <li><strong>Comprehensive Care from Start to Finish</strong> — We guide you through every step of the Teeth-In-A-Day journey.</li>
  <li><strong>A Commitment to Restoring Your Confidence</strong> — We understand the impact of a complete smile on your self-esteem and overall well-being.</li>
</ul>
<h3>Regain Your Smile—Without the Wait</h3>
<p>If you are searching for a fast, reliable, and transformative solution for full arch tooth replacement, Teeth-In-A-Day at Celebrity Smile Studio may be the ideal option. Experience the confidence of a complete smile sooner than you thought possible.</p>
<p><strong>Contact Celebrity Smile Studio in Flourtown today to schedule your Teeth-In-A-Day consultation and discover if you’re a candidate for same-day smile restoration.</strong></p>
    `,
  },

  'cosmetic-dentistry/orthodontics': {
    title: 'Orthodontics | Straighten Your Smile',
    eyebrow: 'Cosmetic Dentistry',
    excerpt: 'Modern orthodontic solutions — Invisalign® — to straighten your smile.',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=1600&q=80',
    seo: {
      title: 'Orthodontics Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Straighten your smile comfortably with advanced orthodontics in Flourtown. Celebrity Smile Studio offers expert care &amp; personalized plans. Schedule a consultation!',
      keywords: 'orthodontics flourtown, braces flourtown, Invisalign flourtown, teeth straightening flourtown',
    },
    content: `
<h1>Orthodontics | Straighten Your Smile</h1>
<h3>Unlock Your Best Smile with Comprehensive Orthodontic Care</h3>
<p>A healthy, properly aligned smile does more than enhance your appearance—it improves oral health, bite function, and long-term dental stability. At Celebrity Smile Studio in Flourtown, we offer comprehensive orthodontic treatment designed to help children, teens, and adults achieve beautifully straight, confident smiles.</p>
<p>Whether you are dealing with crooked teeth, crowding, spacing, or bite misalignment, our experienced team provides personalized orthodontic solutions tailored to your unique goals and lifestyle. We are committed to delivering comfortable, effective care using modern techniques and proven treatment methods.</p><h3>Our Orthodontic Services</h3>
<h3>Invisalign®</h3>
<p>Invisalign offers a discreet and comfortable way to straighten your teeth using a series of custom-made, clear aligners. These virtually invisible trays gently and gradually shift your teeth according to a personalized treatment plan.</p>
<p>Because there are no brackets or wires, Invisalign® allows you to maintain confidence throughout your treatment.</p>
<h3>Benefits of Invisalign®:</h3>
<ul>
  <li>Nearly invisible aligners</li>
  <li>Removable for eating, brushing, and flossing</li>
  <li>No food restrictions</li>
  <li>Comfortable, smooth plastic trays</li>
  <li>Fewer in-office visits (typically every 6–8 weeks)</li>
  <li>Average treatment time often under one year</li>
</ul>
<p>Invisalign® is an excellent option for teens and adults seeking a more flexible and aesthetically subtle orthodontic solution.</p>
<h3>Why Choose Celebrity Smile Studio for Orthodontics in Flourtown?</h3>
<ul>
  <li><strong>Experienced Orthodontic Team</strong> — Our skilled dental professionals have the training and expertise to treat a wide range of orthodontic concerns with precision and care.</li>
  <li><strong>Personalized Treatment Plans</strong> — No two smiles are alike. We develop customized orthodontic plans tailored to your dental needs, goals, and daily routine.</li>
  <li><strong>Comfort-Focused Environment</strong> — We prioritize your comfort at every visit, providing a welcoming and stress-free experience.</li>
  <li><strong>Community-Centered Care</strong> — As proud members of the Flourtown community, we are dedicated to delivering exceptional orthodontic care to our neighbors.</li>
  <li><strong>Patient Education & Empowerment</strong> — We take the time to explain your treatment options clearly, helping you make informed decisions about your smile.</li>
</ul>
<h3>Start Your Journey to a Straighter Smile Today</h3>
<p>Choosing orthodontic treatment is an important step toward improved oral health and lasting confidence. At Celebrity Smile Studio in Flourtown, we are committed to helping you achieve results you’ll love for years to come.</p>
<p><strong>Schedule your orthodontic consultation today and take the first step toward a healthier, beautifully aligned smile.</strong></p>
    `,
  },
  'cosmetic-dentistry/botox': {
    title: 'Botox',
    eyebrow: 'Cosmetic Dentistry',
    excerpt: 'Enhance your smile and relieve facial discomfort with professional Botox therapy.',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=1600&q=80',
    seo: {
      title: 'Botox Dental Treatment in Flourtown, PA | Celebrity Smile Studio',
      description: 'Experience professional dental Botox in Flourtown, PA for cosmetic enhancement, TMJ pain relief, bruxism management, and a more confident smile with expert care.',
      keywords: 'Botox dental treatment Flourtown, dentist Botox services Pennsylvania, dental Botox Cosmetic TMJ relief, Botox for bruxism jaw pain dentist, Botox cosmetic dentistry Flourtown PA, Botox injections by dentist, Botox for gummy smile and wrinkles, therapeutic dental Botox near Flourtown',
    },
    content: `
<h1>Botox Therapy in Celebrity Smile Studio</h1></br>
<p><strong>Enhance your smile and relieve facial discomfort with professional Botox therapy.</strong> Botox® Cosmetic is one of the most popular minimally invasive aesthetic treatments in North America. For over two decades, botulinum toxin type A has been safely and effectively used to soften frown lines, smooth wrinkles, and rejuvenate facial appearance.</p>
<p>At our Celebrity Smile Studio dental practice, we provide Botox therapy not only for facial esthetics but also as an adjunctive treatment for certain dental conditions. With a strong safety profile and extensive clinical research supporting its use, Botox offers both cosmetic and therapeutic benefits when administered by trained professionals.</p>

<h3>How Botox Works</h3>
<p>Botox is the brand name for a purified protein derived from botulinum toxin type A. When precisely injected into targeted facial muscles, it temporarily relaxes muscle activity by blocking nerve signals responsible for muscle contraction.</p>
<p>Because many facial wrinkles are caused by repeated muscle movement (known as dynamic wrinkles), relaxing these muscles allows the overlying skin to appear smoother and more refreshed. Results typically begin to appear within 3 to 10 days after treatment and can last approximately 3 to 4 months. There is no loss of sensation in the treated area, and patients can return to normal activities shortly after the procedure.</p>

<h3>Botox for Facial Esthetics</h3>
<ul>
  <li><strong>Forehead Lines</strong> — Smooth horizontal lines caused by repetitive facial expressions.</li>
  <li><strong>Frown Lines (Glabellar Lines)</strong> — Reduce the appearance of vertical lines between the eyebrows.</li>
  <li><strong>Crow’s Feet</strong> — Soften fine lines around the outer corners of the eyes.</li>
</ul>
<p>These treatments help restore a more youthful, relaxed appearance while maintaining natural facial expressions.</p>

<h3>Therapeutic Dental Uses for Botox</h3>
<p>In addition to cosmetic applications, Botox has valuable clinical uses in dentistry. An increasing number of dentists across North America incorporate Botox as a supportive therapy for specific dental and facial pain conditions.</p>
<ul>
  <li><strong>TMJ (Temporomandibular Joint) Disorders</strong> — Botox can relax overactive jaw muscles, helping reduce tension and chronic jaw pain.</li>
  <li><strong>Bruxism (Teeth Grinding)</strong> — By decreasing the intensity of muscle contractions, Botox may minimize grinding and clenching.</li>
  <li><strong>Facial Pain Relief</strong> — Patients with moderate chronic facial muscle pain may experience significant symptom improvement.</li>
  <li><strong>High Lip Line (Gummy Smile)</strong> — Botox can be used as a conservative, non-surgical option to reduce excessive gum display by limiting upper lip elevation.</li>
</ul>
<p>For certain cases, Botox may be combined with dermal fillers to provide a minimally invasive alternative to more aggressive surgical procedures. Treatment is carefully administered to preserve full lip function for speaking, smiling, and eating while enhancing overall dental esthetics.</p>

<h3>Why Choose Our Celebrity Smile Studio Dental Office for Botox?</h3>
<ul>
  <li><strong>Dental Expertise in Facial Anatomy</strong> — Dentists have extensive training in head and neck anatomy, ensuring precise and safe injections.</li>
  <li><strong>Comprehensive Approach</strong> — We integrate cosmetic and therapeutic treatments to support both appearance and oral health.</li>
  <li><strong>Personalized Treatment Plans</strong> — Every patient receives customized care based on their goals and clinical needs.</li>
  <li><strong>Convenient Scheduling</strong> — Our office offers extended weekday hours and Saturday appointments to better serve our Celebrity Smile Studio patients.</li>
</ul>

<h3>Schedule Your Botox Consultation in Celebrity Smile Studio</h3>
<p>If you are considering Botox for cosmetic enhancement or therapeutic relief from TMJ or facial pain, we invite you to schedule a consultation. Our team will discuss your goals, evaluate your needs, and determine whether Botox therapy is right for you.</p>
<p>Contact our Celebrity Smile Studio dental office today to learn more about how Botox can help you look refreshed, feel comfortable, and smile with confidence.</p>
    `,
  },
'cosmetic-dentistry/tmj': {
    title: 'TMJ Treatment',
    eyebrow: 'Cosmetic Dentistry',
    excerpt: 'Relief from jaw pain, headaches, and discomfort starts with proper TMJ care.',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=1600&q=80',
    seo: {
      title: 'TMJ Treatment in Flourtown, PA | Jaw Pain Relief',
      description: 'Get expert TMJ treatment in Flourtown, PA. We provide relief from jaw pain, headaches, clicking, and teeth grinding with personalized dental care.',
      keywords: 'TMJ treatment Flourtown PA, TMJ dentist near me, jaw pain relief Flourtown, TMJ therapy Pennsylvania, treatment for clicking jaw, bruxism treatment dentist, TMJ headache relief, TMJ specialist Flourtown, night guard for TMJ, TMJ pain dentist PA',
    },
    content: `

<h1>TMJ Treatment in Celebrity Smile Studio</h1></br>
<p><strong>Relief from jaw pain, headaches, and discomfort starts with proper TMJ care.</strong> The temporomandibular joint (TMJ) connects your lower jaw (mandible) to the temporal bone of your skull, located near the temple area. This joint plays a critical role in everyday activities such as speaking, chewing, and yawning.</p>
<p>When the TMJ becomes inflamed, misaligned, or overworked, it can lead to a condition known as TMD (temporomandibular disorder). Because this joint involves bones, cartilage, and multiple supporting muscles, even minor dysfunction can result in significant discomfort and disruption to daily life.</p>

<h3>Common Causes of TMJ Disorders</h3>
<ul>
  <li><strong>Bite Misalignment</strong> — Improper alignment of teeth can place excessive stress on the jaw joint.</li>
  <li><strong>Teeth Grinding or Clenching (Bruxism)</strong> — Repetitive muscle tension can strain the joint and surrounding tissues.</li>
  <li><strong>Jaw Injury or Trauma</strong> — Accidents or impact can damage the joint structure.</li>
  <li><strong>Excess Muscle Tension</strong> — Stress-related clenching can overload the jaw muscles.</li>
  <li><strong>Missing Teeth</strong> — Gaps can alter bite balance and contribute to joint dysfunction.</li>
</ul>

<h3>Symptoms of TMJ Disorder</h3>
<ul>
  <li><strong>Frequent Headaches</strong></li>
  <li><strong>Earaches or Ear Pressure</strong></li>
  <li><strong>Jaw Pain or Muscle Soreness</strong></li>
  <li><strong>Clicking or Popping Sounds in the Jaw</strong></li>
  <li><strong>Difficulty Opening or Closing the Mouth</strong></li>
  <li><strong>Facial Pain or Tenderness</strong></li>
</ul>
<p>If you experience any of these symptoms, a professional evaluation can help determine whether TMJ dysfunction is the underlying cause.</p>

<h3>TMJ Treatment Options</h3>
<p>There is no one-size-fits-all solution for TMJ disorders. Treatment depends on the severity and cause of your condition. Our dental team develops personalized treatment plans designed to relieve pain, restore function, and prevent further damage.</p>
<ul>
  <li><strong>Bite Adjustment</strong> — Correcting imbalances in your bite to reduce stress on the joint.</li>
  <li><strong>Restorative Dentistry</strong> — Replacing missing teeth, repairing worn teeth, or filling gaps to improve alignment.</li>
  <li><strong>Custom Night Guards</strong> — A protective oral appliance that prevents clenching and grinding during sleep.</li>
  <li><strong>Orthodontic Treatment</strong> — Repositioning teeth to improve jaw alignment when necessary.</li>
  <li><strong>Advanced Care Referrals</strong> — In severe or untreated cases, surgical intervention may be considered to repair significant joint damage.</li>
</ul>

<h3>Find Lasting Relief from TMJ Pain</h3>
<p>TMJ discomfort should not interfere with your quality of life. Early diagnosis and conservative treatment can often prevent more serious complications. If you are experiencing jaw pain, headaches, or difficulty chewing, contact our office to schedule a comprehensive TMJ evaluation.</p>
<p>We are committed to helping you regain comfort, restore proper jaw function, and protect your long-term oral health.</p>
    `,
  },

  'oral-surgery/tooth-extraction': {
    title: 'Tooth Extraction',
    eyebrow: 'Oral Surgery',
    excerpt: 'Comfortable, precise tooth extractions performed by our experienced surgical team.',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1600&q=80',
    seo: {
      title: 'Expert Tooth Extraction Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Gentle tooth extraction in Flourtown. Celebrity Smile Studio provides caring and comfortable procedures. We prioritize your comfort and well-being. Schedule your consultation!',
      keywords: 'tooth extraction flourtown, tooth removal flourtown, wisdom tooth extraction flourtown',
    },
    content: `
<h1>Tooth Extraction in Flourtown</h1>

<h3>Comfort-Focused Care You Can Trust at Celebrity Smile Studio</h3>

<p>At <strong>Celebrity Smile Studio in Flourtown</strong>, we understand that the thought of a tooth extraction can feel overwhelming.</p>

<p>Our experienced dental team is committed to making your procedure as smooth, gentle, and stress-free as possible.</p>

<p>In some cases, removing a tooth is the best solution to protect your overall oral health and prevent future complications.</p>

<p>Whether you have a severely damaged tooth or require an extraction as part of orthodontic treatment, we provide expert care with a compassionate approach focused on your comfort.</p>

<p>From consultation to recovery, we ensure you feel informed, relaxed, and confident every step of the way.</p>


<h3>Why You May Need a Tooth Extraction</h3>

<ul>
<li><strong>Severe Tooth Decay</strong> — When a cavity or structural damage is too advanced to be restored with a filling, crown, or root canal.</li>

<li><strong>Orthodontic Treatment</strong> — Creating necessary space to properly align teeth and improve bite function.</li>

<li><strong>Infection Prevention</strong> — Removing a compromised tooth to stop infection from spreading to surrounding teeth or bone.</li>

<li><strong>Dental Trauma</strong> — Extracting teeth that are severely fractured or broken beyond repair.</li>
</ul>


<h3>What to Expect During Your Tooth Extraction at Celebrity Smile Studio</h3>

<ul>
<li><strong>Comprehensive Dental Evaluation</strong> — A thorough examination and digital imaging to determine the best treatment plan.</li>

<li><strong>Comfortable Local Anesthesia</strong> — Numbing the area completely to ensure a pain-free experience.</li>

<li><strong>Gentle, Precise Extraction</strong> — Using minimally invasive techniques to reduce discomfort and promote faster healing.</li>

<li><strong>Detailed Aftercare Instructions</strong> — Clear, step-by-step guidance to support a smooth and comfortable recovery.</li>

<li><strong>Follow-Up Monitoring</strong> — Ongoing care to ensure proper healing and prevent complications.</li>
</ul>


<h3>Why Choose Celebrity Smile Studio for Tooth Extraction in Flourtown?</h3>

<ul>
<li><strong>Experienced &amp; Compassionate Dental Team</strong> — Your comfort and safety are always our top priorities.</li>

<li><strong>Advanced, Minimally Invasive Techniques</strong> — Designed to reduce discomfort and speed up recovery time.</li>

<li><strong>Calm &amp; Relaxing Environment</strong> — We create a reassuring setting to help ease dental anxiety.</li>

<li><strong>Personalized Post-Extraction Care</strong> — Tailored recovery instructions based on your specific needs.</li>

<li><strong>Trusted Local Dental Practice</strong> — Proudly serving the Flourtown community with high-quality dental care.</li>

<li><strong>Clear Communication</strong> — We take the time to explain your procedure and answer all your questions.</li>
</ul>

<p>At <strong>Celebrity Smile Studio</strong>, we believe a tooth extraction should be a comfortable and worry-free experience.</p>

<p>If you need a professional and gentle tooth extraction in Flourtown, contact our office today to schedule your consultation and protect your long-term oral health.</p>
    `,
  },

  'endodontics/root-canal-treatment': {
    title: 'Root Canal Treatment',
    eyebrow: 'Endodontics',
    excerpt: 'Modern root canal therapy — gentle, effective, and designed to save your natural tooth.',
    image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=1600&q=80',
    seo: {
      title: 'Root Canal Treatment | Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Save your natural smile with expert root canal treatment at Celebrity Smile Studio in Flourtown. Relieve pain, stop infection, and restore your tooth’s health, comfortably and effectively.',
      keywords: 'root canal flourtown, root canal treatment flourtown, endodontist flourtown',
    },
    content: `
<h1>Root Canal Treatment</h1>
<h3>Saving Your Natural Tooth with Expert Root Canal Therapy at Celebrity Smile Studio</h3>

<p>When the inner pulp of a tooth becomes infected or damaged, prompt treatment is essential to relieve pain and prevent tooth loss.</p>

<p>At <strong>Celebrity Smile Studio in Flourtown</strong>, we provide gentle and highly effective root canal treatment designed to eliminate infection, restore tooth function, and preserve your natural smile.</p>

<p>Root canal therapy is often the best alternative to tooth extraction. Instead of removing the tooth, we carefully clean and seal the infected area, protecting the remaining structure and allowing you to maintain a healthy, complete smile.</p>

<p>Our experienced dental team focuses on precision, comfort, and long-term success so you can feel confident throughout your treatment.</p>


<h3>Why You May Need Root Canal Treatment</h3>

<ul>
<li><strong>Deep Tooth Decay</strong> — When cavities extend into the pulp, causing infection and inflammation.</li>

<li><strong>Cracked or Fractured Teeth</strong> — Damage that exposes the inner pulp to harmful bacteria.</li>

<li><strong>Repeated Dental Procedures</strong> — Multiple restorations on the same tooth may irritate or compromise the pulp.</li>

<li><strong>Dental Trauma</strong> — Injury to the tooth that affects the pulp, even without visible cracks.</li>

<li><strong>Advanced Gum Disease</strong> — Infection that spreads to the tooth’s inner tissues.</li>
</ul>


<h3>What to Expect During Your Root Canal Procedure at Celebrity Smile Studio</h3>

<ul>
<li><strong>Comprehensive Examination &amp; Digital X-Rays</strong> — Detailed evaluation to determine if root canal therapy is the appropriate solution.</li>

<li><strong>Comfortable Local Anesthesia</strong> — Ensuring a completely pain-free experience throughout the procedure.</li>

<li><strong>Accessing the Pulp Chamber</strong> — A small opening is created to reach the infected or damaged pulp.</li>

<li><strong>Cleaning &amp; Shaping the Root Canals</strong> — Specialized instruments remove infected tissue and thoroughly clean the canals.</li>

<li><strong>Disinfection</strong> — The canals are carefully disinfected to eliminate bacteria and reduce the risk of reinfection.</li>

<li><strong>Filling &amp; Sealing with Gutta-Percha</strong> — The canals are filled with a biocompatible material and securely sealed.</li>

<li><strong>Final Restoration with a Crown</strong> — In most cases, a custom dental crown is placed to strengthen and protect the treated tooth for long-term durability.</li>
</ul>


<h3>Why Choose Celebrity Smile Studio for Root Canal Treatment in Flourtown?</h3>

<ul>
<li><strong>Experienced &amp; Gentle Dentists</strong> — Skilled professionals dedicated to comfortable and successful outcomes.</li>

<li><strong>Advanced Dental Technology</strong> — Digital imaging and modern rotary instruments for precise, efficient care.</li>

<li><strong>Comfort-Focused Approach</strong> — Effective anesthesia and a calming environment to reduce dental anxiety.</li>

<li><strong>High Success Rate</strong> — Root canal therapy is a proven, reliable method for saving natural teeth.</li>

<li><strong>Commitment to Preserving Your Smile</strong> — We prioritize saving your natural teeth whenever possible.</li>

<li><strong>Improved Oral Health</strong> — Eliminates infection and protects surrounding teeth and tissues.</li>

<li><strong>Restored Function &amp; Strength</strong> — With proper restoration, your treated tooth can function normally for chewing and speaking.</li>

<li><strong>Compassionate, Supportive Team</strong> — We guide you through every step with clear communication and personalized care.</li>
</ul>

<p>Don’t let an infected or damaged tooth lead to unnecessary extraction.</p>

<p>Root canal treatment at <strong>Celebrity Smile Studio</strong> offers a safe and effective way to relieve pain, save your natural tooth, and maintain a healthy smile.</p>

<p>Contact us today to schedule your consultation for root canal treatment in Flourtown and protect your long-term oral health.</p>
    `,
  },

  'periodontist/lanap-procedure': {
    title: 'LANAP Procedure',
    eyebrow: 'Periodontal Care',
    excerpt: 'Laser-assisted gum disease treatment — minimally invasive, FDA-cleared, and clinically proven.',
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=1600&q=80',
    seo: {
      title: 'LANAP Procedure | Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Experience a gentler, more effective way to treat gum disease with the LANAP procedure at Celebrity Smile Studio in Flourtown. No cutting, no sutures—just healthier gums and faster healing.',
      keywords: 'LANAP flourtown, laser gum treatment flourtown, laser periodontal therapy, LANAP procedure',
    },
    content: `
<h1>LANAP® Procedure in Flourtown | Advanced Laser Gum Disease Treatment</h1>

<h3>Gentle, Minimally Invasive Gum Disease Care at Celebrity Smile Studio</h3>

<p>Gum disease can significantly impact your oral health and overall well-being if left untreated.</p>

<p>At <strong>Celebrity Smile Studio in Flourtown</strong>, we proudly offer the advanced <strong>LANAP® (Laser-Assisted New Attachment Procedure)</strong> — a minimally invasive, FDA-cleared laser treatment designed to eliminate infection and restore gum health without traditional cutting or sutures.</p>

<p>Unlike conventional gum surgery, the LANAP procedure uses precise laser technology to target harmful bacteria and diseased tissue while preserving healthy gum structure.</p>

<p>This modern approach promotes faster healing, reduces discomfort, and supports the regeneration of healthy gum tissue and bone — helping you rebuild a strong foundation for long-term oral health.</p>

<h3>Benefits of the LANAP® Procedure</h3>

<ul>
<li><strong>Minimally Invasive Treatment</strong> — No scalpels or stitches, resulting in a more comfortable experience.</li>

<li><strong>Reduced Bleeding &amp; Swelling</strong> — Laser technology seals blood vessels and nerve endings during treatment.</li>

<li><strong>Faster Healing Time</strong> — Less trauma to surrounding tissue promotes quicker recovery.</li>

<li><strong>Preserves Healthy Gum Tissue</strong> — Targets only infected areas while protecting healthy tissue.</li>

<li><strong>Stimulates Tissue &amp; Bone Regeneration</strong> — Encourages natural healing and reattachment of gums to teeth.</li>

<li><strong>Less Post-Treatment Sensitivity</strong> — Patients often report minimal discomfort after the procedure.</li>

<li><strong>Scientifically Proven &amp; FDA-Cleared</strong> — A safe and effective solution for moderate to advanced periodontal disease.</li>

<li><strong>Improved Long-Term Outcomes</strong> — Helps stop disease progression and supports lasting gum stability.</li>
</ul>

<h3>What to Expect During Your LANAP Treatment at Celebrity Smile Studio</h3>

<ul>
<li><strong>Comprehensive Periodontal Evaluation</strong> — Detailed assessment of your gum health to determine if LANAP is right for you.</li>

<li><strong>Personalized Treatment Plan</strong> — Customized care based on the severity of your gum disease.</li>

<li><strong>Precise Laser Therapy</strong> — A specialized dental laser gently removes infected tissue and bacteria from gum pockets.</li>

<li><strong>No Cutting or Sutures</strong> — A major advantage over traditional gum surgery.</li>

<li><strong>Comfortable Local Anesthesia</strong> — Ensures a relaxed and pain-free experience.</li>

<li><strong>Clear Post-Treatment Instructions</strong> — Guidance to promote optimal healing at home.</li>

<li><strong>Follow-Up Monitoring</strong> — Ongoing care to track healing and maintain results.</li>
</ul>

<h3>Why Choose Celebrity Smile Studio for LANAP® in Flourtown?</h3>

<ul>
<li><strong>Certified LANAP-Trained Dentists</strong> — Specialized training in the official LANAP protocol.</li>

<li><strong>PerioLase® MVP-7™ Laser Technology</strong> — The FDA-cleared laser specifically designed for the LANAP procedure.</li>

<li><strong>Commitment to Minimally Invasive Dentistry</strong> — Focused on patient comfort and faster recovery.</li>

<li><strong>Experienced &amp; Compassionate Team</strong> — Dedicated to providing supportive and personalized care.</li>

<li><strong>Customized Treatment Approach</strong> — Tailored solutions designed for optimal long-term gum health.</li>

<li><strong>Focus on Lasting Results</strong> — Our goal is to help you maintain healthy gums for life.</li>

<li><strong>Enhanced Quality of Life</strong> — Healthier gums contribute to improved comfort, confidence, and overall wellness.</li>
</ul>

<p>If you’re looking for a gentle, effective alternative to traditional gum surgery, the <strong>LANAP® procedure at Celebrity Smile Studio in Flourtown</strong> offers a revolutionary solution for treating gum disease.</p>

<p>Contact us today to schedule your consultation and discover how laser periodontal therapy can restore your gum health and protect your smile for years to come.</p>
    `,
  },

  'preventative-dental-care/dental-examinations': {
    title: 'Comprehensive Dental Examinations',
    eyebrow: 'Preventative Care',
    excerpt: 'A thorough evaluation of your oral health — the foundation for personalized, lasting dental well-being.',
    image: 'https://images.unsplash.com/photo-1588776814546-1ffbb93a5289?w=1600&q=80',
    seo: {
      title: 'Dental Examinations Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Stay ahead of dental issues with comprehensive dental examinations at Celebrity Smile Studio in Flourtown. Personalized care, advanced technology, and a smile-first approach you can trust.',
      keywords: 'dental exam flourtown, dental examination flourtown, oral health checkup flourtown, oral cancer screening',
    },
    content: `
<h1>Comprehensive Dental Examinations in Flourtown</h1>

<h3>Your Roadmap to Lifelong Oral Health at Celebrity Smile Studio</h3>

<p>A healthy smile begins with knowledge — not guesswork.</p>

<p>At <strong>Celebrity Smile Studio in Flourtown</strong>, our comprehensive dental examinations provide a detailed understanding of your oral health, forming the foundation for personalized, long-term care.</p>

<p>This is more than a routine check-up. It’s a complete evaluation of your teeth, gums, bite, and oral tissues designed to detect concerns early and prevent future dental problems.</p>

<p>By thoroughly assessing your entire oral environment, we create a customized treatment plan that keeps your smile healthy, functional, and beautiful for years to come.</p>


<h3>What to Expect During Your Comprehensive Dental Exam</h3>

<ul>
<li><strong>Detailed Visual Examination</strong> — Careful inspection of your teeth, gums, tongue, and soft tissues to check for cavities, wear, inflammation, or abnormalities.</li>

<li><strong>Periodontal (Gum) Evaluation</strong> — Measuring gum pocket depths and assessing for early signs of gum disease.</li>

<li><strong>Bite &amp; Occlusion Analysis</strong> — Evaluating how your teeth fit together to identify bite issues or potential TMJ concerns.</li>

<li><strong>Digital X-Rays (When Necessary)</strong> — Advanced imaging to detect hidden decay, bone loss, impacted teeth, or other underlying conditions.</li>

<li><strong>Oral Cancer Screening</strong> — Thorough screening for early signs of oral cancer or abnormal tissue changes.</li>

<li><strong>Personalized Consultation</strong> — Clear explanation of findings along with customized treatment recommendations tailored to your needs.</li>
</ul>


<h3>Why Choose Celebrity Smile Studio for Dental Examinations in Flourtown?</h3>

<ul>
<li><strong>Thorough &amp; Detailed Assessments</strong> — We take the time to evaluate every aspect of your oral health.</li>

<li><strong>Advanced Diagnostic Technology</strong> — Modern tools for accurate, early detection and precise treatment planning.</li>

<li><strong>Patient-Centered Care</strong> — Your comfort, questions, and understanding are always our priority.</li>

<li><strong>Prevention-Focused Philosophy</strong> — Early detection helps prevent more complex and costly treatments later.</li>

<li><strong>Clear &amp; Honest Communication</strong> — We ensure you fully understand your oral health and treatment options.</li>

<li><strong>Trusted Flourtown Dental Practice</strong> — Proudly serving individuals and families in our community.</li>
</ul>

<p>A comprehensive dental examination is one of the most important steps you can take toward protecting your long-term oral health.</p>

<p>Routine exams allow for early detection, timely treatment, and prevention of serious dental concerns.</p>

<p>Schedule your comprehensive dental exam at <strong>Celebrity Smile Studio in Flourtown</strong> today and take the first step toward a healthier, more confident smile.</p>
    `,
  },

  'preventative-dental-care/dental-x-rays': {
    title: 'Dental X-Rays',
    eyebrow: 'Preventative Care',
    excerpt: 'Digital dental X-rays — precision diagnostic imaging with minimal radiation exposure.',
    image: 'https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?w=1600&q=80',
    seo: {
      title: 'Dental X-Rays Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Protect your oral health with digital dental X-rays at Celebrity Smile Studio in Flourtown. Early detection, personalized care, and advanced technology in one visit.',
      keywords: 'dental x-rays flourtown, digital dental imaging flourtown, dental radiographs',
    },
    content: `
<h1>Dental X-Rays in Flourtown</h1>

<h3>The Vital Role of Digital Dental X-Rays at Celebrity Smile Studio</h3>

<p>Many dental concerns develop beneath the surface — where they cannot be seen during a routine visual exam.</p>

<p>At <strong>Celebrity Smile Studio in Flourtown</strong>, we use advanced digital dental X-ray technology to capture detailed images of your teeth, roots, jawbone, and surrounding structures.</p>

<p>Dental X-rays allow us to detect problems early, diagnose conditions accurately, and create precise treatment plans tailored to your needs.</p>

<p>Think of X-rays as a deeper look into your oral health — helping us identify hidden cavities, bone loss, impacted teeth, infections, and other concerns before they become serious.</p>


<h3>What to Expect During Your Dental X-Ray Appointment</h3>

<ul>
<li><strong>Quick &amp; Comfortable Process</strong> — Digital X-rays are fast, efficient, and designed for patient comfort.</li>

<li><strong>Reduced Radiation Exposure</strong> — Modern digital technology significantly lowers radiation levels compared to traditional film X-rays.</li>

<li><strong>Different Types of X-Rays</strong> — We may take bitewing, periapical, or panoramic images depending on your specific diagnostic needs.</li>

<li><strong>Immediate Image Results</strong> — Digital images are available instantly for real-time evaluation.</li>

<li><strong>Expert Analysis</strong> — Our experienced dental professionals carefully review each image for early signs of decay, infection, or structural concerns.</li>

<li><strong>Clear Explanation of Findings</strong> — We walk you through the results so you fully understand your oral health status.</li>
</ul>


<h3>Why Dental X-Rays Are Essential for Your Oral Health</h3>

<ul>
<li><strong>Early Detection of Hidden Issues</strong> — Identifies cavities, infections, impacted teeth, and bone loss before symptoms appear.</li>

<li><strong>Accurate Treatment Planning</strong> — Provides detailed information for restorative, orthodontic, periodontal, or surgical procedures.</li>

<li><strong>Comprehensive Dental Evaluation</strong> — An essential component of a thorough dental examination.</li>

<li><strong>Improved Long-Term Outcomes</strong> — Early diagnosis helps prevent more complex and costly treatments later.</li>

<li><strong>Safe &amp; Patient-Focused Technology</strong> — Designed with your comfort and safety as a priority.</li>

<li><strong>Empowered Decision-Making</strong> — Gives you the information needed to make confident choices about your dental care.</li>
</ul>

<p>Dental X-rays are a critical part of maintaining a healthy, confident smile.</p>

<p>By identifying hidden concerns early, we can provide proactive care that protects your long-term oral health.</p>

<p>Schedule your dental examination and digital X-ray appointment at <strong>Celebrity Smile Studio in Flourtown</strong> today and gain a complete picture of your smile.</p>
    `,
  },

  'preventative-dental-care/dental-cleaning': {
    title: 'Professional Dental Cleaning',
    eyebrow: 'Preventative Care',
    excerpt: 'A thorough professional cleaning to remove plaque and tartar and keep your smile bright and healthy.',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=1600&q=80',
    seo: {
      title: 'Dental Cleaning Flourtown, Chestnut Hill &amp; Philadelphia | Celebrity Smile Studio',
      description: 'Prevent cavities &amp; gum disease with a gentle dental cleaning in Flourtown. Celebrity Smile Studio provides expert care in a relaxing environment. Book your appointment!',
      keywords: 'dental cleaning flourtown, teeth cleaning flourtown, professional dental cleaning, prophylaxis flourtown',
    },
    content: `
<h1>Professional Dental Cleaning in Flourtown</h1>
<p><strong>A brighter, healthier smile begins with a professional dental cleaning.</strong> While brushing and flossing at home are essential for maintaining good oral hygiene, they cannot remove all plaque and tartar buildup. At Celebrity Smile Studio in Flourtown, our professional dental cleanings are designed to protect your teeth, prevent gum disease, and keep your smile looking its very best.</p>
<p>A routine dental cleaning does more than polish your teeth — it helps prevent cavities, gingivitis, periodontal disease, and other oral health concerns. Think of it as a fresh start for your smile, promoting long-term dental health and overall well-being.</p>

<h3>What to Expect During Your Dental Cleaning Appointment</h3>
<ul>
  <li><strong>Comprehensive Oral Examination</strong> — We begin with a thorough evaluation of your teeth and gums to detect early signs of decay, gum disease, or other dental concerns.</li>
  <li><strong>Plaque and Tartar Removal</strong> — Using specialized dental instruments, our skilled hygienists gently remove plaque and hardened tartar from above and below the gum line.</li>
  <li><strong>Professional Teeth Polishing</strong> — Your teeth are polished to eliminate surface stains and leave them smooth, clean, and refreshed.</li>
  <li><strong>Fluoride Treatment (If Recommended)</strong> — Fluoride helps strengthen tooth enamel and provides added protection against cavities.</li>
  <li><strong>Personalized Oral Hygiene Guidance</strong> — We provide tailored recommendations and preventive tips to help you maintain optimal oral health between visits.</li>
</ul>

<h3>Why Choose Celebrity Smile Studio for Dental Cleanings in Flourtown?</h3>
<ul>
  <li><strong>Experienced & Compassionate Team</strong> — Our hygienists are dedicated to delivering gentle, thorough care in a comfortable setting.</li>
  <li><strong>Advanced Dental Technology</strong> — We use modern equipment and proven techniques for efficient and effective cleanings.</li>
  <li><strong>Comfort-Focused Environment</strong> — Your comfort is our priority. We strive to make every visit stress-free and relaxing.</li>
  <li><strong>Preventive Care Approach</strong> — We emphasize education and preventive dentistry to help you avoid costly and complex treatments in the future.</li>
  <li><strong>Proudly Serving the Flourtown Community</strong> — As a trusted local dental practice, we are committed to helping our neighbors achieve healthy, confident smiles.</li>
</ul>

<h3>How Often Should You Schedule a Dental Cleaning?</h3>
<p>For most patients, we recommend a professional dental cleaning every six months. Regular visits help maintain healthy gums, prevent tooth decay, and ensure early detection of potential dental issues.</p>
<p>Ready to enjoy a cleaner, brighter smile? Contact Celebrity Smile Studio in Flourtown today to schedule your professional dental cleaning and experience exceptional dental care tailored to you.</p>
    `,
  },
};

// ─── PATIENT CENTER DATA ──────────────────────────────────────────────────────
export const PATIENT_CENTER_DATA = {
 /* 'patient-portal': {
    title: 'Patient Portal', icon: '🔐',
    seo: {
      title: 'Patient Portal | Celebrity Smile Studio – flourtown, PA',
      description: 'Access your dental records, upcoming appointments, and treatment plans securely through the Celebrity Smile Studio patient portal. Fast, easy, and available 24/7.',
      keywords: 'patient portal dental, online dental records flourtown, dental appointment management, celebrity smile studio portal',
    },
    content: `
<h2>Patient Portal</h2>
<p>Access your health records, view upcoming appointments, review treatment plans, and communicate securely with our team through our online patient portal. It's the easiest way to stay on top of your dental care from anywhere.</p>
<p>To get set up with the patient portal, contact our office at <a href="tel:2152335811">(215) 233-5811</a> and a team member will walk you through the registration process.</p>
    `,
  }, 

  'new-patient-forms': {
    title: 'New Patient Forms', icon: '📋',
    seo: {
      title: 'New Patient Forms | Celebrity Smile Studio – Flourtown, PA',
      description: 'Download and complete your new patient registration, HIPAA notice, and acknowledgement forms before your first visit to Celebrity Smile Studio in Flourtown, PA.',
      keywords: 'new patient forms dental Flourtown, dental patient registration, HIPAA dental forms, celebrity smile studio new patient',
    },
    content: '',
  },*/

  'financing': {
    title: 'Patient Financing', icon: '💳',
    seo: {
      title: 'Dental Financing & Payment Options | Celebrity Smile Studio – Flourtown, PA',
      description: 'Affordable dental care is within reach. Explore CareCredit, HSA/FSA, and flexible payment plans at Celebrity Smile Studio in Flourtown, PA.',
      keywords: 'dental financing flourtown, CareCredit dentist flourtown, affordable dental care, dental payment plans flourtown',
    },
    content: `
<h2>Patient Financing</h2>
<h3>Patient Financing in Flourtown</h3>
<p><strong>Affordable dental care made simple and stress-free.</strong> At Celebrity Smile Studio in Flourtown, we believe financial concerns should never prevent you from achieving a healthy, confident smile. That’s why we offer flexible dental financing options designed to fit your budget and treatment needs.</p>
<p>Whether you require preventive care, cosmetic dentistry, restorative procedures, or advanced treatments, our team is committed to helping you explore convenient payment solutions so you can begin treatment without delay.</p>

<h3>CareCredit® Financing</h3>
<p>We proudly accept CareCredit®, a trusted healthcare financing program that allows patients to pay for dental treatments over time.</p>
<ul>
  <li><strong>Immediate Treatment Access</strong> — Start your dental care right away without postponing necessary procedures.</li>
  <li><strong>Convenient Monthly Payments</strong> — Choose manageable payment plans that align with your financial comfort.</li>
  <li><strong>Promotional Financing Options</strong> — Special financing offers may be available (subject to approval).</li>
  <li><strong>Coverage for Cosmetic & Elective Treatments</strong> — Use CareCredit for services not typically covered by dental insurance.</li>
</ul>
<p>The application process is quick and secure, and approvals are often provided within minutes. Our friendly team is happy to guide you through the process.</p>

<h3>Additional Flexible Payment Options</h3>
<ul>
  <li><strong>Major Credit Cards</strong> — Visa, MasterCard, Discover, and other major cards accepted.</li>
  <li><strong>Debit Card Payments</strong> — Secure and convenient payment method.</li>
  <li><strong>In-Office Payment Arrangements</strong> — Customized solutions based on your treatment plan.</li>
  <li><strong>HSA & FSA Accounts</strong> — We accept Health Savings Accounts and Flexible Spending Accounts.</li>
</ul>
<p>Before beginning treatment, we provide a clear breakdown of costs and review all available payment options so you can make informed decisions with confidence.</p>

<h3>Dental Insurance Assistance</h3>
<p>Navigating dental insurance can be complex — we’re here to help simplify the process. Our knowledgeable front desk team will:</p>
<ul>
  <li><strong>Verify Your Benefits</strong> — Confirm your coverage details prior to treatment.</li>
  <li><strong>Submit Claims on Your Behalf</strong> — Handle insurance paperwork to save you time.</li>
  <li><strong>Maximize Your Coverage</strong> — Help you make the most of your available benefits.</li>
  <li><strong>Explain Out-of-Pocket Costs</strong> — Provide transparent estimates so there are no unexpected surprises.</li>
</ul>

<h3>Invest in Your Smile with Confidence</h3>
<p>Your smile is an investment in your health, confidence, and overall well-being. With flexible dental financing options and personalized payment solutions, Celebrity Smile Studio makes high-quality dental care accessible for individuals and families in Flourtown.</p>
<p>Contact Celebrity Smile Studio today to learn more about CareCredit® and our patient financing options — and take the next step toward a healthier, brighter smile.</p>
    `,
  },

  'testimonials': {
    title: 'Patient Testimonials', icon: '⭐',
    seo: {
      title: 'Patient Reviews & Testimonials | Celebrity Smile Studio – Flourtown, PA',
      description: 'See what real patients say about Celebrity Smile Studio in Flourtown, CA. Read reviews on Google and Yelp and discover why our patients love us.',
      keywords: 'dental reviews flourtown, celebrity smile studio reviews, dentist testimonials flourtown, best dentist flourtown',
    },
    content: `
<h2>What Our Patients Say</h2>
<p>We are grateful for the kind words our patients share — they inspire us every day. Read more of our reviews on <a href="https://www.google.com/search?q=Celebrity+Smiles+Flourtown+PA+Reviews" target="_blank" rel="noreferrer">Google</a> </p>
<blockquote>"Great experience as a first time patient. Everyone was extremely friendly, professional, and thorough. Highly recommend!"<br><strong>— Darren Butz, Flourtown</strong></blockquote>
<blockquote>"Chelsey was great, in and out in an hour; hadnt been to the dentist for 2 years and it was painless; shout out to my coworker Kristina who referred me; great choice, very happy!!"<br><strong>— Colin McDermott, Flourtown</strong></blockquote>
<blockquote>"I continue to be impressed by the care I receive every time I go to Celebrity Smile Studio for my routine dental exams. They are prompt, thorough and efficient. I never feel as though they are trying to push work that doesn’t need to be done."<br><strong>— Lindsey Sachs, Flourtown</strong></blockquote>
    `,
  },

  /*'office-tour': {
    title: 'Office Tour', icon: '🏢',
    seo: {
      title: 'Office Tour | Celebrity Smile Studio – Flourtown, PA',
      description: 'Take a virtual tour of Celebrity Smile Studio in flourtown. Explore our modern, welcoming facility with state-of-the-art technology and patient-friendly amenities.',
      keywords: 'dental office tour flourtown, celebrity smile studio office, modern dental office flourtown, dental facility tour',
    },
    content: `
<h2>Office Tour</h2>
<p>We've designed our flourtown office to be a calm, welcoming space where patients of all ages and abilities feel comfortable from the moment they walk in. Our state-of-the-art facility features the latest dental technology, modern treatment rooms, and thoughtful amenities to make your visit as pleasant as possible.</p>
<h3>Our Office Features:</h3>
<ul>
  <li>Spacious, calming reception area</li>
  <li>Digital X-ray and 3D imaging suite</li>
  <li>Modern, fully equipped treatment rooms</li>
  <li>Sensory-friendly accommodations for special needs patients</li>
  <li>Accessible facilities for all mobility levels</li>
</ul>
<p>Come visit us at <strong>1811 Bethlehem Pike,Ste B235, Flourtown, PA 19031</strong>.</p>
    `,
  }, */

 /* 'patient-survey': {
    title: 'Patient Survey', icon: '📋',
    seo: {
      title: 'Patient Survey | Celebrity Smile Studio – Flourtown, PA',
      description: 'Share your experience at Celebrity Smile Studio. Your feedback helps us improve and provide the best dental care in Flourtown, PA.',
      keywords: 'dental patient feedback flourtown, celebrity smile studio survey, dental review flourtown',
    },
    content: `
<h2>Patient Survey</h2>
<p>Your feedback is incredibly important to us. Every response is read by our team, and your suggestions directly shape how we improve the care we provide. We are committed to continuous improvement and patient satisfaction.</p>
<p>You can also leave us a review on <a href="https://g.co/kgs/Nt9UTjN" target="_blank" rel="noreferrer">Google</a> — it means the world to our team.</p>
    `,
  }, */

 /* 'office-policies': {
    title: 'Office Policies', icon: '📄',
    seo: {
      title: 'Office Policies | Celebrity Smile Studio – Flourtown, PA',
      description: 'Review appointment, cancellation, payment, and insurance policies at Celebrity Smile Studio in Flourtown, PA. We make dental care simple and transparent.',
      keywords: 'dental office policies flourtown, appointment policy dentist, dental cancellation policy flourtown, dental insurance flourtown',
    },
    content: `
<h2>Office Policies</h2>
<p>If you have any questions about our office policies, please call our office during business hours at <a href="tel:2152335811">(215) 233-5811</a>.</p>
<h3>Appointments</h3>
<p>If you are a <strong>new patient</strong>, please arrive at our office <strong>30 minutes</strong> prior to your scheduled time to allow for check-in and paperwork. For your convenience, you may complete new patient forms ahead of time and bring them with you.</p>
<p>If you are a <strong>returning patient</strong>, we ask that you arrive at least <strong>10 minutes</strong> before your scheduled appointment. This extra time allows us to get you through check-in and update any necessary information.</p>
<h3>Cancellations</h3>
<p>We understand that unexpected circumstances arise. Please be aware that your appointment is reserved time solely for you. If you need to change or cancel your appointment, we ask that you give us at least <strong>48 hours notice</strong>. This allows us to accommodate other patients who may be waiting for an appointment.</p>
<h3>Payment Options</h3>
<p>We accept cash, checks, Visa, Mastercard, Discover, and American Express.</p>
<h3>Financing</h3>
<p>We offer <a href="https://www.carecredit.com" target="_blank" rel="noreferrer">CareCredit</a> and <a href="https://www.lendingclub.com" target="_blank" rel="noreferrer">LendingClub</a> financing to make dental treatments affordable. Please call our office if you have any questions.</p>
<h3>Insurance</h3>
<p>We accept most major PPO and Discount Dental programs. See our <a href="/patient-center/financing">Financing page</a> for a full list of accepted insurance plans.</p>
    `,
  }, */

 /* 'common-questions': {
    title: 'Common Questions', icon: '❓',
    seo: {
      title: 'Frequently Asked Questions | Celebrity Smile Studio – Flourtown, PA',
      description: 'Find answers to the most common dental questions at Celebrity Smile Studio in Flourtown. From insurance and scheduling to emergency care and special needs dentistry.',
      keywords: 'dental FAQ flourtown, dental questions flourtown, celebrity smile studio FAQ, dentist questions flourtown',
    },
    content: `
<h2>Common Questions</h2>
<h3>Can I complete the new patient forms before my first appointment?</h3>
<p>Yes, you can download and print the forms on the new patient forms page. Fill them out and either mail the forms to us or bring them with you during for your first appointment.</p>
<h3>Which dental insurance or discount plans do you accept?</h3>
<p>We work with many dental insurance providers and are happy to help you maximize your benefits.</p>
<p>If you are unsure about your coverage, our knowledgeable front desk team will gladly verify your benefits and explain your out-of-pocket responsibilities before treatment begins.</p>
<h3>What do I do if I have a dental emergency?</h3>
<p>Call our office any time you have an emergency, even if it’s after regular hours. If the office is closed, there will be a recording with instructions on what to do and who to contact in case of an emergency.</p>
<h3>What if I need to reschedule my appointment?</h3>
<p>Every patient is important to us and we schedule carefully to set aside the time everyone needs to receive the best treatment possible. However, we understand that there may be times when you must change your appointment. If you need to reschedule, please call our office no later than 48 hours before your scheduled appointment. We ask that you try to avoid last-minute cancellations whenever possible.</p>
    `,
  }, */

  /*'dental-links': {
    title: 'Dental Links', icon: '🔗',
    seo: {
      title: 'Dental Resources & Links | Celebrity Smile Studio – Flourtown, PA',
      description: 'Explore trusted dental health resources recommended by Celebrity Smile Studio. Links to ADA, AAPD, Invisalign, CareCredit, and more.',
      keywords: 'dental resources flourtown, oral health links, ADA dental information, celebrity smile studio resources',
    },
    content: `
<h2>Helpful Dental Resources</h2>
<p>We believe an informed patient is a healthier patient. The following links provide reliable information about oral health from trusted organizations:</p>
<ul>
  <li><a href="https://www.ada.org" target="_blank" rel="noreferrer">American Dental Association (ADA)</a></li>
  <li><a href="https://www.mouthhealthy.org" target="_blank" rel="noreferrer">MouthHealthy.org — ADA Patient Education</a></li>
  <li><a href="https://www.aapd.org" target="_blank" rel="noreferrer">American Academy of Pediatric Dentistry</a></li>
  <li><a href="https://www.perio.org" target="_blank" rel="noreferrer">American Academy of Periodontology</a></li>
  <li><a href="https://www.carecredit.com" target="_blank" rel="noreferrer">CareCredit Patient Financing</a></li>
  <li><a href="https://www.invisalign.com" target="_blank" rel="noreferrer">Invisalign® — Clear Aligner Treatment</a></li>
</ul>
    `,
  }, */

  /*'emergency-care': {
    title: 'Emergency Dental Care', icon: '🚨',
    seo: {
      title: 'Emergency Dental Care | Celebrity Smile Studio – Flourtown, CA',
      description: 'Dental emergency in Flourtown? Celebrity Smile Studio offers same-day emergency appointments. Call (215) 233-5811 immediately for urgent dental care.',
      keywords: 'emergency dentist flourtown, same day dental appointment, dental emergency flourtown, knocked out tooth flourtown, urgent dental care',
    },
    content: `
<h2>Emergency Dental Care</h2>
<p>Dental injuries and severe dental pain require immediate attention. Call our office immediately at <strong><a href="tel:2152335811">(215) 233-5811</a></strong> — we reserve same-day emergency slots and will do everything possible to see you right away.</p>
<h3>Chipped Tooth</h3>
<p>In the event of a chipped tooth, visit a dentist within 2–3 hours. A chipped tooth may be saved if tended to quickly. Before your emergency appointment, apply gentle pressure to the gums around the tooth to stop bleeding — never apply direct force to the chipped tooth. Rinse your mouth with warm water and apply cold compresses to control swelling. If you still have the tooth piece that was chipped off, bring it with you — it may be bonded back into place.</p>
<h3>Knocked-Out Tooth</h3>
<p>Trauma powerful enough to knock out a tooth may sometimes require an emergency room visit. If the tooth can be recovered, handle it only by the crown (the white part) — never touch the root. Gently rinse it in cool water, carefully re-insert it into the empty socket if possible, and hold it in place with a clean cloth. If you cannot re-insert it, keep the tooth moist in milk, saline solution, or saliva and call us immediately. Time is critical — the sooner you act, the better the chance of saving the tooth.</p>
<h3>Other Dental Emergencies</h3>
<p>Other emergencies requiring immediate attention include:</p>
<ul>
  <li><strong>Severe toothache</strong> — Rinse with warm water and call us immediately.</li>
  <li><strong>Cracked teeth</strong> — Rinse mouth, apply cold compress to reduce swelling, call us.</li>
  <li><strong>Lost filling or crown</strong> — Temporary dental cement from a pharmacy can help protect the tooth until your appointment.</li>
  <li><strong>Dental abscess</strong> — A dental abscess is serious and can spread. Call us or go to an emergency room immediately.</li>
  <li><strong>Objects stuck between teeth</strong> — Try gentle flossing; never use sharp objects. Call us if you cannot remove it.</li>
</ul>
<div class="info-box">
  <strong>Emergency Line:</strong> Call <a href="tel:2152335811">(215) 233-5811</a> immediately for any dental emergency. We are committed to seeing emergency patients as soon as possible.
</div>
    `,
  }, */

  'smile-gallery': {
    title: 'Smile Gallery', icon: '😁',
    seo: {
      title: 'Smile Gallery – Before & After Results | Celebrity Smile Studio – Flourtown, PA',
      description: 'View real patient smile transformations at Celebrity Smile Studio in Flourtown. Before and after photos showcasing implants, veneers, whitening, and more.',
      keywords: 'smile gallery flourtown, dental before after flourtown, cosmetic dentistry results, dental transformation flourtown',
    },
    content: `
<h2>Smile Gallery</h2>
<p>The transformations in our gallery represent real patients who trusted Celebrity Smile Studio with their smiles. Before-and-after photos are provided with patient consent — individual results may vary.</p>
<p>Our cosmetic and restorative procedures include dental implants, full arch restorations, All-on-4®, teeth whitening, Invisalign, and smile makeovers. Every result is the product of our team's dedication to artistry, precision, and genuinely caring about each patient's outcome.</p>
<p>Want to see what we can do for your smile? <a href="/book-appointment">Schedule a free consultation</a> today — we'd love to discuss your goals.</p>
    `,
  },

  /* 'video': {
    title: 'Video', icon: '🎥',
    seo: {
      title: 'Patient Education Videos | Celebrity Smile Studio – Flourtown, PA',
      description: 'Watch informative dental videos from Celebrity Smile Studio. Learn about our procedures, meet our team, and discover what to expect during your first visit.',
      keywords: 'dental videos flourtown, patient education dentistry, celebrity smile studio video, dental procedure videos',
    },
    content: `
<h2>Video</h2>
<p>Watch our patient education videos and office tour footage to learn more about our services and what to expect at Celebrity Smile Studio in Flourtown. Our videos cover topics ranging from how dental implants work to what to expect at your first visit.</p>
<p>Have a question you'd like us to address? <a href="/contact">Contact us</a> and let us know.</p>
    `,
  }, */
};

// ─── DOCTORS DATA ─────────────────────────────────────────────────────────────
export const DOCTORS_DATA = [
  {
    name: 'Dr. Taral T. Mehta', credentials: 'DMD',
    slug: 'dr-mehta', role: 'Lead Dentist', badge: 'Lead Doctor', avatar: 'TM',
    specialty: 'General & Special Care Dentistry',
    bio: 'Taral T. Mehta, DMD, has over ten years of experience as a dentist. After graduating with a Bachelor of Sciences degree in Biology from Villanova University in Villanova, PA, and a Certificate in BioMedical Sciences from the Philadelphia College of Osteopathic Medicine in Philadelphia, PA',
    image: '/images/doctors/dr-mehta.jpg',
    content: `
<h2>Dr. Taral T. Mehta, DMD</h2>
<p>Taral T. Mehta, DMD, has over ten years of experience as a dentist. After graduating with a Bachelor of Sciences degree in Biology from Villanova University in Villanova, PA, and a Certificate in BioMedical Sciences from the Philadelphia College of Osteopathic Medicine in Philadelphia, PA</p>
<p> Dr. Mehta obtained his Doctorate of Dental Medicine (DMD) from Kornberg School of Dentistry Temple University in Philadelphia, PA. Upon graduation in 2002, Dr. Mehta received comprehensive multidisciplinary training to provide the best quality of dental care to all patients. In late 2004, Dr. Mehta began practicing in Flourtown, PA implementing his knowledge and modernizing the office to its current state today.</p>
<h3>Education & Training</h3>
<ul>
  <li>Bachelor of Sciences degree in Biology from Villanova University in Villanova, PA</li>
  <li>Certificate in BioMedical Sciences from the Philadelphia College of Osteopathic Medicine</li>
  <li>Doctorate of Dental Medicine (DMD) from Kornberg School of Dentistry Temple University in Philadelphia, PA</li>
  <li>Member of the American Dental Association (ADA)</li>
  <li>Member of Academy of General Dentistry (AGD)</li>
  <li>Member of Pennsylvania Dental Association, Montgomery Bucks Dental Society, and Delaware State Dental Society</li>
</ul>
<h3>Areas of Focus</h3>
<p>Dr. Mehta has pursued further continuing education in the fields of endodontics, oral surgery, diagnostic, restorative, cosmetic and implant dentistry. He is an active member of the American Dental Association (ADA), the Academy of General Dentistry (AGD), Pennsylvania Dental Association, Montgomery Bucks Dental Society, and Delaware State Dental Society. Dr. Mehta’s office offers a wide scope of services, veneers, invisalign, the latest in tooth colored restorations, crown and bridge works, root canals, oral surgery, and emergency dental care. </p>
<p>The office prides itself in its preventive approach to dental care. Dr. Mehta promises to provide each patient with an honest dental health assessment without the pressure for unnecessary procedures. With his training background, Dr. Mehta believes in educating patients about their dental health so they can make an informed decision about their dental health care. Dr. Mehta treats each patient with a gentle caring approach and always puts patients first and with their best interests in mind.</p>
    `,
    seo: {
      title: 'Dr. Taral T. Mehta - Celebrity Smile Studio',
      description: 'Taral T. Mehta, DMD, has over ten years of experience as a dentist. He promises to provide each patient with an honest dental health assessment without the pressure for unnecessary procedures. Call now!',
    },
  },
  {
    name: 'Dr. Randy Nolf', credentials: 'DDS',
    slug: 'dr-randy-nolf', role: 'Periodontist', badge: 'Periodontist', avatar: 'RN',
    specialty: 'General & Family Dentistry',
    bio: 'Dr. Randy Nolf, DDS is a periodontics practitioner in Bethlehem, PA and has been practicing for 37 years. He graduated from Temple Dental Sch in 1975 and practices periodontics.',
    image: '/images/doctors/dr-randy.png',
    content: `
<h2>Dr. Randy Nolf, DDS</h2>
<p>Dr. Randy Nolf, DDS is a periodontics practitioner in Bethlehem, PA and has been practicing for 37 years. </p>
<h3>Education & Training</h3>
<ul>
  <li>Graduated from Temple Dental Sch in 1975 and practices periodontics.</li>
</ul>
<h3>Areas of Focus</h3>
<p>Laser-assisted new attachment procedure (LANAP) is a surgical therapy for the treatment of periodontitis, intended to work through regeneration rather than resection.</p>
<p>We recommend you watch the following informative video on LANAP procedure before your come in for your appointment: <a href="https://youtu.be/U64z9HgAZdo" target="_blank">https://youtu.be/U64z9HgAZdo</a></p>
    `,
    seo: {
      title: 'Dr. Randy Nolf - Celebrity Smile Studio',
      description: 'Dr. Randy Nolf, DDS is a periodontics practitioner in Bethlehem, PA, &amp; has been practicing for 37 years. Visit our site to book an appointment online or contact us at (215) 233-5811.',
    },
  },
  {
    name: 'Dr. Nishit Sachde', credentials: '',
    slug: 'dr-nishit-sachde', role: 'Lead Dentist', badge: 'Lead Doctor', avatar: 'NS',
    specialty: 'Implant Dentistry',
    bio: 'Dr. Nishit Sachde is a compassionate and detail-oriented dentist with a strong passion for biomimetic and conservative dentistry. He believes in preserving natural tooth structure whenever possible and providing minimally invasive treatments that promote long-term oral health, function, and esthetics.',
    image: '/images/doctors/dr-sachde.jpeg',
    content: `
<h2>Dr. Nishit Sachde</h2>
<p>Dr. Nishit Sachde is a compassionate and detail-oriented dentist with a strong passion for biomimetic and conservative dentistry. He believes in preserving natural tooth structure whenever possible and providing minimally invasive treatments that promote long-term oral health, function, and esthetics.</p>
<h3>Education & Training</h3>
<ul>
  <li>Doctor of Dental Surgery (DDS) degree from the University of the Pacific in San Francisco.</li>
  <li>Currently advancing expertise in implant dentistry through the AAID Implant MaxiCourse.</li>
</ul>
<h3>Areas of Focus</h3>
<p>Dr. Sachde began his dental career in India, where he practiced for two years before earning his Doctor of Dental Surgery (DDS) degree from the University of the Pacific in San Francisco. He is committed to continuous learning and is currently advancing his expertise in implant dentistry through the AAID Implant MaxiCourse to provide comprehensive, high-quality care to his patients.</p>
<p>Giving back to the community has always been important to Dr. Sachde. He has volunteered with multiple organizations to deliver dental care to underserved populations, reflecting his dedication to service.</p>
<p>Outside the office, Dr. Sachde enjoys playing pickleball and badminton and spending quality time with his family. He strives to create a welcoming environment where patients feel comfortable, informed, and genuinely cared for.</p>
    `,
    seo: {
      title: 'Dr. Nishit Sachde - Celebrity Smile Studio',
      description: 'Dr. Nishit Sachde is a compassionate and detail-oriented dentist with a strong passion for biomimetic and conservative dentistry. He believes in preserving natural tooth structure whenever possible and providing minimally invasive treatments that promote long-term oral health, function, and esthetics. Book your appointment at Celebrity Smile Studio now.',
    },
  },
  {
    name: 'Dr. David Sopinsky', credentials: '',
    slug: 'dr-sopinsky', role: 'Lead Dentist', badge: 'Lead Doctor', avatar: 'DS',
    specialty: 'Invisalign® Preferred Provider',
    bio: 'Dr. David A. Sopinsky attended The College of New Jersey where he received his Bachelor’s Degree in Computer Science and Mathematics. He went on to graduate from Temple University Kornberg School of Dentistry in 2003. He is licensed in both Pennsylvania and New Jersey.',
    image: '/images/doctors/dr-david.png',
    content: `
<h2>Dr. David Sopinsky</h2>
<p>Dr. David A. Sopinsky attended The College of New Jersey where he received his Bachelor’s Degree in Computer Science and Mathematics. He went on to graduate from Temple University Kornberg School of Dentistry in 2003. He is licensed in both Pennsylvania and New Jersey.</p>
<h3>Education & Training</h3>
<ul>
  <li>Bachelor’s Degree in Computer Science and Mathematics</li>
  <li>Graduate from Temple University Kornberg School of Dentistry</li>
  <li>Member of the International Team for Implantology and the ADA</li>
</ul>
<h3>Areas of Focus</h3>
<p>Dr. Sopinsky has extensive experience in dentistry for more than a decade. He is an Invisalign® Preferred Provider, completed the AIC Implant Training Course, and is a member of the International Team for Implantology and the ADA.</p>
    `,
    seo: {
      title: 'Dr. David Sopinsky - Celebrity Smile Studio',
      description: 'Dr. Sopinsky has extensive experience in dentistry for more than a decade. He is licensed in both Pennsylvania and New Jersey. Book your appointment at Celebrity Smile Studio now.',
    },
  },
  {
    name: 'Dr. Kaushal Shah', credentials: 'DDS',
    slug: 'dr-kaushal-shah', role: 'Lead Dentist', badge: 'Lead Doctor', avatar: 'KS',
    specialty: 'Cosmetic, periodontics, and dental implant restorations',
    bio: 'Dr. Kaushal Shah earned her Doctorate in Dental Surgery from the University of Maryland Dental School where she completed a senior clerkship in Pediatric Dentistry. Dr. Shah went on to complete a general practice residency at the VA Medical Hospital in Baltimore, Maryland.',
    image: '/images/doctors/dr-kaush.jpg',
    content: `
<h2>Dr. Kaushal Shah</h2>
<p>Dr. Kaushal Shah earned her Doctorate in Dental Surgery from the University of Maryland Dental School where she completed a senior clerkship in Pediatric Dentistry. Dr. Shah went on to complete a general practice residency at the VA Medical Hospital in Baltimore, Maryland. </p>
<p>Here, she completed extensive training in cosmetic, periodontics, and dental implant restorations. She holds a Bachelor of Science degree in Physiology and Neurobiology from the University of Maryland, College Park. She is fluent in English, Hindi, and Gujarati.</p>
<h3>Education & Training</h3>
<ul>
  <li>Doctorate in Dental Surgery from the University of Maryland Dental School</li>
  <li>Completed extensive training in cosmetic, periodontics, and dental implant restorations</li>
  <li>Bachelor of Science degree in Physiology and Neurobiology from the University of Maryland, College Park</li>
  <li>Member of the American Dental Association, PA Dental Association, Academy of General Dentistry, Academy of Laser Dentistry</li>
</ul>
<h3>Areas of Focus</h3>
<p>Dr. Shah loves helping patients with their dental needs and considers it the most gratifying part of her job. She has special interests in cosmetic, laser, and implant dentistry. Dr. Shah takes pride in offering advanced and customized treatments to her patients by staying current through continuing education seminars. This has led her to exceed the state's requirements for continuing education.</p>
<p>Dr. Shah is a member of the American Dental Association, PA Dental Association, Academy of General Dentistry, Academy of Laser Dentistry and is also an Elite preferred provider for Invisalign.</p>
    `,
    seo: {
      title: 'Dr. Kaushal Shah - Celebrity Smile Studio',
      description: 'Dr. Shah takes pride in offering advanced and customized treatments to her patients by staying current through continuing education seminars. This has led her to exceed the states requirements for continuing education.',
    },
  },
];

// ─── REVIEWS ──────────────────────────────────────────────────────────────────
export const REVIEWS_DATA = [
 
  { id: 2, name: 'Lindsey Sachs',    rating: 5, date: '2 months ago',   avatar: 'LS', text: 'I continue to be impressed by the care I receive every time I go to Celebrity Smile Studio for my routine dental exams. They are prompt, thorough and efficient. I never feel as though they are trying to push work that doesn’t need to be done.' },
  { id: 3, name: 'Colin McDermott',     rating: 5, date: '4 months ago',   avatar: 'CM', text: 'Chelsey was great, in and out in an hour; hadnt been to the dentist for 2 years and it was painless; shout out to my coworker Kristina who referred me; great choice, very happy!!' },
  { id: 6, name: 'Lawrence Ryder',      rating: 5, date: '6 months ago', avatar: 'CF', text: 'Absolutely perfect very kind, understanding and so experienced . When I go to my appointment I know they are going to take such good care of me as nervous as I am. Five stars from me for Celebrity Smile Studio.' },
  { id: 4, name: 'Darren Butz',  rating: 5, date: '4 months ago',   avatar: 'DB', text: 'Great experience as a first time patient. Everyone was extremely friendly, professional, and thorough. Highly recommend!' },
  { id: 5, name: 'Mike W',         rating: 5, date: '5 months ago',   avatar: 'MW',  text: 'I recently changed from my old dentist to Celebrity Smile Studio and I’m happy I did. I had my first visit with them and not only are they thorough and knowledgeable, but everyone is so nice. I’m happy with Mr recent switch to Celebrity Smile Studio as my new dental office.' },
   { id: 1, name: 'Dominique A',  rating: 5, date: '2 months ago',   avatar: 'DA', text: 'I had such a great experience! I felt like I was actually cared for, no rush, and explained everything to me thoroughly. The office is very clean, everyone was so nice. My cleaning went smoothly as well! Definitely glad I was recommended to come here. I live in Delaware and this office is definitely worth the drive. Thank you so much! 🫶🏾' },
];

// ─── OFFICE HOURS ─────────────────────────────────────────────────────────────
export const OFFICE_HOURS = [
  { day: 'Monday', hours: '9:00 AM – 5:00 PM', closed: false },
  { day: 'Tuesday', hours: '9:00 AM – 5:00 PM', closed: false },
  { day: 'Wednesday', hours: '9:00 AM – 5:00 PM', closed: false },
  { day: 'Thursday',  hours: '9:00 AM – 5:00 PM', closed: false },
  { day: 'Friday',    hours: '9:00 AM – 1:00 PM', closed: false  },
];

// ─── PRACTICE INFO ────────────────────────────────────────────────────────────
export const PRACTICE_INFO = {
  name: 'Celebrity Smile Studio',
  tagline: 'General, Family & Special Care',
  phone: '(215) 233-5811', phoneRaw: '2152335811',
  fax: '(215) 233-5811',
  email: 'info@flourtowndentist.com',
  address: '1811 Bethlehem Pike',
  city: 'Flourtown', state: 'PA', zip: '19031',
  fullAddress: '1811 Bethlehem Pike,Ste B235, Flourtown, PA 19031',
  mapUrl: 'https://www.google.com/maps?ll=40.109017,-75.215373&z=16&t=m&hl=en-US&gl=US&mapclient=embed&cid=17383465960446132134',
 // instagram: 'http://www.instagram.com/elementsdentistry',
  facebook:'https://www.facebook.com/celebritysmiles',
  yelp: 'https://www.yelp.com/biz/celebrity-smiles-flourtown-2',
  google: 'https://goo.gl/maps/szk2gS7Ycu52',
  //bookingUrl: 'https://flexbook.me/elements/website',
};


// ─── TOP-LEVEL LANDING PAGES ──────────────────────────────────────────────────
// These power the clickable parent nav items: /services, /doctors,
// /patient-center, /contact — each renders as a full editable page.
// Edit the `content` field below using the same HTML tags as other pages.
// ─────────────────────────────────────────────────────────────────────────────

export const LANDING_PAGES_DATA = {

  // ── /services ──────────────────────────────────────────────────────────────
  services: {
    title: 'Our Dental Services',
    eyebrow: 'What We Offer',
    excerpt: 'Comprehensive dental care for every stage of life — cosmetic, restorative, preventative, and specialty services all under one roof.',
    image: 'https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?w=1600&q=80',
    seo: {
      title: 'Dental Services | Celebrity Smile Studio – Flourtown, PA',
      description: 'Explore the full range of dental services at Celebrity Smile Studio in Flourtown — from cosmetic and implants to family care, endodontics, and periodontics.',
      keywords: 'dental services flourtown, cosmetic dentistry flourtown, dental implants flourtown, family dentist flourtown, celebrity smile studio services',
    },
    content: `
<h1>Our Dental Services</h1>
<h3>Comprehensive Care for Every Smile, Every Stage of Life</h3>
<p>At <strong>Celebrity Smile Studio</strong> in Flourtown, we offer a complete range of dental services designed to keep your smile healthy, beautiful, and functional — no matter your age or dental history.</p>
<p>Whether you're visiting for a routine cleaning, seeking cosmetic improvements, or needing advanced restorative treatment, our experienced team provides personalized, compassionate care with the latest dental technology.</p>

<h3>Our Core Services</h3>
<ul>
  <li><strong>Cosmetic Dentistry</strong> — Dental implants, full arch restoration, All-on-4®, Teeth-in-a-Day, orthodontics, Botox, and TMJ therapy to enhance your smile and confidence.</li>
  <li><strong>Expert Oral Surgery</strong> — Tooth extractions, wisdom teeth removal, bone grafting, and implant placement performed with precision and care.</li>
  <li><strong>Endodontics</strong> — Root canal treatment to save infected or damaged teeth, relieving pain and preserving your natural smile.</li>
  <li><strong>Periodontics</strong> — Specialized gum health care including scaling, root planing, and the advanced LANAP® laser procedure.</li>
  <li><strong>Preventative Dental Care</strong> — Comprehensive exams, digital X-rays, and professional cleanings to catch problems early and keep your smile strong.</li>
  <li><strong>Family Dentistry</strong> — Gentle, welcoming care for patients of all ages — from children's first visits to senior dental health.</li>
</ul>

<h3>Why Choose Celebrity Smile Studio?</h3>
<ul>
  <li><strong>All Specialties Under One Roof</strong> — No referrals to outside offices. Our team covers every aspect of your dental health.</li>
  <li><strong>State-of-the-Art Technology</strong> — Digital X-rays, 3D imaging, laser dentistry, and modern treatment rooms for precise, comfortable care.</li>
  <li><strong>Experienced, Caring Team</strong> — Our dentists bring decades of combined experience across general, specialty, and cosmetic dentistry.</li>
  <li><strong>Flexible Scheduling & Financing</strong> — Evening and Saturday hours, plus CareCredit and payment plan options.</li>
  <li><strong>Welcoming to All Patients</strong> — Including those with special needs, dental anxiety, or complex dental histories.</li>
</ul>

<p>Explore each service category using the menu above, or <a href="/contact">contact us</a> to speak with a team member about which services are right for you.</p>
<p><strong>Ready to get started? <a href="/book-appointment">Book your appointment online</a> or call us at <a href="tel:2152335811">(215) 233-5811</a>.</strong></p>
    `,
  },

  // ── /doctors ───────────────────────────────────────────────────────────────
  doctors: {
    title: 'Meet Our Doctors',
    eyebrow: 'Our Expert Team',
    excerpt: 'Get to know the skilled, caring dental professionals behind every smile transformation at Celebrity Smile Studio.',
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=1600&q=80',
    seo: {
      title: 'Meet Our Dentists | Celebrity Smile Studio – Flourtown, PA',
      description: 'Meet the experienced dental team at Celebrity Smile Studio in Flourtown. Learn about our doctors backgrounds, specialties, and commitment to exceptional patient care.',
      keywords: 'dentist flourtown, celebrity smile studio doctors, dental team flourtown, best dentist flourtown PA',
    },
    content: `
<h1>Meet Our Doctors</h1>
<h3>Experienced, Compassionate Dental Professionals You Can Trust</h3>
<p>At <strong>Celebrity Smile Studio</strong>, our strength is our team. Each of our doctors brings specialized training, genuine passion for dentistry, and a shared commitment to treating every patient with the care and respect they deserve.</p>
<p>From general and family dentistry to implants, orthodontics, periodontics, and special care — our doctors cover every area of dental health so you and your family can receive comprehensive treatment under one roof.</p>

<h3>Our Approach to Patient Care</h3>
<ul>
  <li><strong>Honest Assessments</strong> — We never recommend unnecessary procedures. Every treatment recommendation is explained clearly and honestly.</li>
  <li><strong>Patient-First Philosophy</strong> — We take the time to listen to your concerns and tailor care to your individual needs and goals.</li>
  <li><strong>Continuing Education</strong> — Our doctors regularly pursue advanced training to stay at the forefront of modern dentistry.</li>
  <li><strong>Gentle, Comfortable Care</strong> — Whether you have dental anxiety, special needs, or a complex history, our team is trained to make your experience positive.</li>
</ul>

<p>Select a doctor from the menu to read their full biography, training, and areas of expertise.</p>
<p><strong>Have questions about which doctor is right for you? <a href="/contact">Contact our team</a> — we're happy to help.</strong></p>
    `,
  },

  // ── /patient-center ────────────────────────────────────────────────────────
  'patient-center': {
    title: 'Patient Center',
    eyebrow: 'Resources for Our Patients',
    excerpt: 'Everything you need before, during, and after your visit — financing, FAQs, portal access, and more.',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1600&q=80',
    seo: {
      title: 'Patient Center | Celebrity Smile Studio – Flourtown, PA',
      description: 'Explore patient resources at Celebrity Smile Studio — financing options, FAQs, patient portal, office policies, smile gallery, and more. We make dental care easy.',
      keywords: 'patient center dental flourtown, dental patient resources, celebrity smile studio patient info, dental FAQ flourtown, dental financing flourtown',
    },
    content: `
<h1>Patient Center</h1>
<h3>We Make Every Part of Your Dental Experience Simple</h3>
<p>At <strong>Celebrity Smile Studio</strong>, we believe great dental care extends beyond the treatment chair. Our Patient Center is your go-to resource for everything you need to prepare for your visit, manage your care, and get the most from your dental benefits.</p>

<h3>What You'll Find Here</h3>
<ul>
  <li><strong>Patient Portal</strong> — Securely access your records, view appointments, and communicate with our team online.</li>
  <li><strong>Financing Options</strong> — Explore CareCredit, HSA/FSA, and flexible payment plans to make treatment affordable.</li>
  <li><strong>Patient Testimonials</strong> — Read real reviews from patients across Flourtown and beyond.</li>
  <li><strong>Office Tour</strong> — Preview our modern, welcoming facility before your first visit.</li>
  <li><strong>Common Questions</strong> — Answers to the questions we hear most — from insurance and scheduling to emergency care.</li>
  <li><strong>Smile Gallery</strong> — Browse real before-and-after results from our cosmetic and restorative procedures.</li>
</ul>

<h3>New Patients</h3>
<p>Welcome! We recommend reviewing our <a href="/patient-center/common-questions">Common Questions</a> before your first visit. If you'd like to complete paperwork in advance, just give us a call at <a href="tel:2152335811">(215) 233-5811</a>.</p>

<h3>Insurance & Payment</h3>
<p>We accept most major PPO dental insurance plans and offer a range of flexible payment options. Visit our <a href="/patient-center/financing">Financing page</a> for full details or call us and we'll verify your benefits.</p>
    `,
  },

  // ── /contact ───────────────────────────────────────────────────────────────
  contact: {
    title: 'Contact Us',
    eyebrow: 'Get In Touch',
    excerpt: 'We are here to help. Reach out to schedule an appointment, ask a question, or find your way to our Flourtown office.',
    image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=1600&q=80',
    seo: {
      title: 'Contact Us | Celebrity Smile Studio – Flourtown, PA',
      description: 'Contact Celebrity Smile Studio in Flourtown, CA. Call, email, or book online. We offer convenient hours, same-day emergency slots, and friendly staff ready to help.',
      keywords: 'contact dentist flourtown, celebrity smile studio contact, book dental appointment flourtown, dental office phone flourtown',
    },
    content: `
<h1>Contact Celebrity Smile Studio</h1>
<h3>We'd Love to Hear From You</h3>
<p>Whether you're ready to book an appointment, have a question about our services, or need directions to our office — our friendly team is here to help. We strive to respond to all inquiries promptly and make your experience as convenient as possible.</p>

<h3>Ways to Reach Us</h3>
<ul>
  <li><strong>Phone</strong> — Call us at <a href="tel:2152335811">(215) 233-5811</a> during office hours. For dental emergencies after hours, listen to our message for next-step instructions.</li>
  <li><strong>Email</strong> — Send us a note at <a href="mailto:info@flourtowndentist.com">info@flourtowndentist.com</a> and we'll get back to you within one business day.</li>
  <li><strong>Book Online</strong> — Use our <a href="/book-appointment">online booking page</a> to request an appointment at your convenience, 24/7.</li>
  <li><strong>Location</strong> — We're located at <strong>1811 Bethlehem Pike, Ste B235, Flourtown, PA 19031</strong>. See our <a href="/contact/location">Location page</a> for directions and parking details.</li>
</ul>

<h3>Office Hours</h3>
<ul>
  <li>Monday: 9:00 AM – 5:00 PM</li>
  <li>Tuesday: 9:00 AM – 5:00 PM</li>
  <li>Wednesday: 9:00 AM – 5:00 PM</li>
  <li>Thursday: 9:00 AM – 5:00 PM</li>
  <li>Friday: 9:00 AM – 1:00 PM</li>
</ul>

<div class="info-box">
  <strong>Dental Emergency?</strong> Call <a href="tel:2152335811">(215) 233-5811</a> immediately. We reserve same-day emergency slots and will do everything possible to see you right away.
</div>
    `,
  },
};
